/**
 * Generated by orval v8.18.0 🍺
 * Do not edit manually.
 * LiftAI API
 * LiftAI elevator/lift asset-management REST API.
 * OpenAPI spec version: 1.0.0 (v1)
 */
import * as zod from 'zod';


export const usersRetrievePathEmailRegExp = new RegExp('^[^/]+$');


export const UsersRetrieveParams = zod.object({
  "email": zod.string().regex(usersRetrievePathEmailRegExp)
})

export const usersRetrieveResponseUsernameMax = 150;


export const usersRetrieveResponseUsernameRegExp = new RegExp('^[\\w.@+-]+$');
export const usersRetrieveResponseEmailMax = 254;

export const usersRetrieveResponsePhoneNumberMax = 128;



export const UsersRetrieveResponse = zod.object({
  "id": zod.string().uuid(),
  "username": zod.string().max(usersRetrieveResponseUsernameMax).regex(usersRetrieveResponseUsernameRegExp).describe('Required. 150 characters or fewer. Letters, digits and @\/.\/+\/-\/_ only.'),
  "email": zod.string().email().max(usersRetrieveResponseEmailMax).optional(),
  "phoneNumber": zod.string().max(usersRetrieveResponsePhoneNumberMax).optional(),
  "fullName": zod.string(),
  "consultantGroup": zod.string().nullable(),
  "clientGroup": zod.string().nullable(),
  "role": zod.union([zod.enum(['consultant', 'client', 'service_provider']).describe('\* `consultant` - consultant\n\* `client` - client\n\* `service_provider` - service_provider'),zod.literal(null)]).nullable(),
  "isLiftaiAdmin": zod.boolean(),
  "isGroupAdmin": zod.boolean(),
  "canAccessMechanicAssistant": zod.boolean().optional(),
  "canAccessSalesGenie": zod.boolean().optional(),
  "canAccessElevatorInsights": zod.boolean().optional(),
  "isDemo": zod.boolean()
}).strict()

export const usersPermissionsRetrievePathEmailRegExp = new RegExp('^[^/]+$');


export const UsersPermissionsRetrieveParams = zod.object({
  "email": zod.string().regex(usersPermissionsRetrievePathEmailRegExp)
})

export const usersPermissionsRetrieveResponseUsernameMax = 150;


export const usersPermissionsRetrieveResponseUsernameRegExp = new RegExp('^[\\w.@+-]+$');
export const usersPermissionsRetrieveResponseEmailMax = 254;

export const usersPermissionsRetrieveResponsePhoneNumberMax = 128;



export const UsersPermissionsRetrieveResponse = zod.object({
  "id": zod.string().uuid(),
  "username": zod.string().max(usersPermissionsRetrieveResponseUsernameMax).regex(usersPermissionsRetrieveResponseUsernameRegExp).describe('Required. 150 characters or fewer. Letters, digits and @\/.\/+\/-\/_ only.'),
  "email": zod.string().email().max(usersPermissionsRetrieveResponseEmailMax).optional(),
  "phoneNumber": zod.string().max(usersPermissionsRetrieveResponsePhoneNumberMax).optional(),
  "fullName": zod.string(),
  "consultantGroup": zod.string().nullable(),
  "clientGroup": zod.string().nullable(),
  "role": zod.union([zod.enum(['consultant', 'client', 'service_provider']).describe('\* `consultant` - consultant\n\* `client` - client\n\* `service_provider` - service_provider'),zod.literal(null)]).nullable(),
  "isLiftaiAdmin": zod.boolean(),
  "isGroupAdmin": zod.boolean(),
  "canAccessMechanicAssistant": zod.boolean().optional(),
  "canAccessSalesGenie": zod.boolean().optional(),
  "canAccessElevatorInsights": zod.boolean().optional(),
  "isDemo": zod.boolean()
}).strict()

export const UsersVerifyRetrieveParams = zod.object({
  "email": zod.string()
})

export const UsersVerifyRetrieveResponse = zod.object({
  "verified": zod.boolean(),
  "reason": zod.string().optional()
}).strict().describe('Response for AccountVerificationView. `reason` is only present on 400.')

/**
 * Adds a GET-only ``aggregate`` action to a viewset.
 *
 * The viewset must declare ``AGGREGATE_CONFIG: AggregateConfig`` and a
 * ``filterset_class``. GET-only because the chat loopback only issues GET.
 */
export const usersCarsListPathOwnerEmailRegExp = new RegExp('^[^/]+$');


export const UsersCarsListParams = zod.object({
  "ownerEmail": zod.string().regex(usersCarsListPathOwnerEmailRegExp)
})

export const UsersCarsListQueryParams = zod.object({
  "client_id": zod.array(zod.string()).optional().describe('Multiple values may be separated by commas.'),
  "ordering": zod.array(zod.enum(['-name', 'name'])).optional().describe('Ordering\n\n\* `name` - Name\n\* `-name` - Name (descending)'),
  "portfolio_id": zod.string().uuid().optional(),
  "property_id": zod.string().uuid().optional(),
  "query": zod.string().optional(),
  "search_cars": zod.string().optional()
})

export const usersCarsListResponseClientIdMax = 255;

export const usersCarsListResponseNumLandingsMin = 0;
export const usersCarsListResponseNumLandingsMax = 2147483647;

export const usersCarsListResponsePropertyOneAddressOneRawMax = 200;

export const usersCarsListResponsePropertyOneAddressOneFormattedMax = 200;

export const usersCarsListResponsePropertyOneAddressOneStreetNumberMax = 20;

export const usersCarsListResponsePropertyOneRegionMax = 255;

export const usersCarsListResponsePropertyOneClientIdMax = 255;

export const usersCarsListResponsePropertyOneLatDefault = 0;
export const usersCarsListResponsePropertyOneLngDefault = 0;
export const usersCarsListResponsePropertyOnePropertyManagerOneOwnerOneUsernameMax = 150;


export const usersCarsListResponsePropertyOnePropertyManagerOneOwnerOneUsernameRegExp = new RegExp('^[\\w.@+-]+$');
export const usersCarsListResponsePropertyOnePropertyManagerOneOwnerOneEmailMax = 254;

export const usersCarsListResponsePropertyOnePropertyManagerOneOwnerOnePhoneNumberMax = 128;

export const usersCarsListResponsePropertyOneConsultantGroupOneOwnerOneUsernameMax = 150;


export const usersCarsListResponsePropertyOneConsultantGroupOneOwnerOneUsernameRegExp = new RegExp('^[\\w.@+-]+$');
export const usersCarsListResponsePropertyOneConsultantGroupOneOwnerOneEmailMax = 254;

export const usersCarsListResponsePropertyOneConsultantGroupOneOwnerOnePhoneNumberMax = 128;

export const usersCarsListResponsePropertyOneConsultantGroupOneConsultantsItemUsernameMax = 150;


export const usersCarsListResponsePropertyOneConsultantGroupOneConsultantsItemUsernameRegExp = new RegExp('^[\\w.@+-]+$');
export const usersCarsListResponsePropertyOneConsultantGroupOneConsultantsItemEmailMax = 254;

export const usersCarsListResponsePropertyOneConsultantGroupOneConsultantsItemPhoneNumberMax = 128;

export const usersCarsListResponsePropertyOneConsultantGroupOneFileRegExp = new RegExp('(?:jpg|png|jpeg)$');
export const usersCarsListResponsePropertyOneAssignedConsultantOneUsernameMax = 150;


export const usersCarsListResponsePropertyOneAssignedConsultantOneUsernameRegExp = new RegExp('^[\\w.@+-]+$');
export const usersCarsListResponsePropertyOneAssignedConsultantOneEmailMax = 254;

export const usersCarsListResponsePropertyOneAssignedConsultantOnePhoneNumberMax = 128;

export const usersCarsListResponsePropertyOneBuildingNumberMax = 255;

export const usersCarsListResponsePropertyOneContactOneNameMax = 255;

export const usersCarsListResponseInstallationYearMin = 0;
export const usersCarsListResponseInstallationYearMax = 2147483647;

export const usersCarsListResponseModernizationYearMin = 0;
export const usersCarsListResponseModernizationYearMax = 2147483647;

export const usersCarsListResponseNumEntrancesMin = 0;
export const usersCarsListResponseNumEntrancesMax = 2147483647;

export const usersCarsListResponseSpeedFpmMin = 0;
export const usersCarsListResponseSpeedFpmMax = 2147483647;

export const usersCarsListResponseCapacityLbsMin = 0;
export const usersCarsListResponseCapacityLbsMax = 2147483647;



export const UsersCarsListResponseItem = zod.object({
  "id": zod.string().uuid(),
  "clientId": zod.string().max(usersCarsListResponseClientIdMax).nullish(),
  "customerAccounts": zod.array(zod.object({
  "id": zod.string().uuid(),
  "name": zod.string()
}).strict().describe('A subclass of DRF\'s ModelSerializer which realizes when fields it is\nserializing are to related objects which also have NestableModelSerializers\ndefined for them and uses those serializers instead of the default\nModelSerializer that DRF would use.\n\nThis ModelSerializer takes an additional `fields` argument that\ncontrols which fields should be displayed.\nFor more information, refer to the documentation:\nhttps:\/\/www.django-rest-framework.org\/api-guide\/serializers\/#dynamically-modifying-fields\n\n\nExample:\nPortfolioSerializer(required=False, fields=[\"id\", \"name\"])')),
  "name": zod.string(),
  "status": zod.string(),
  "numLandings": zod.number().min(usersCarsListResponseNumLandingsMin).max(usersCarsListResponseNumLandingsMax).nullish(),
  "elevatorType": zod.union([zod.enum(['Traction', 'Hydro', 'Other', 'escalator', 'hydraulic-passenger', 'hydraulic-service', 'mrl-traction', 'geared-passenger', 'geared-traction', 'gearless-traction', 'gearless-passenger', 'wheelchair-lift', 'dumbwaiter', 'passenger-service', 'high-rise-passenger', 'low-rise-passenger', 'passenger', 'freight']).describe('\* `Traction` - Traction\n\* `Hydro` - Hydro\n\* `Other` - Other\n\* `escalator` - Escalator\n\* `hydraulic-passenger` - Hydraulic Passenger\n\* `hydraulic-service` - Hydraulic Service\n\* `mrl-traction` - MRL Traction\n\* `geared-passenger` - Geared Passenger\n\* `geared-traction` - Geared Traction\n\* `gearless-traction` - Gearless Traction\n\* `gearless-passenger` - Gearless Passenger\n\* `wheelchair-lift` - Wheelchair Lift\n\* `dumbwaiter` - Dumbwaiter\n\* `passenger-service` - Passenger\/Service\n\* `high-rise-passenger` - High Rise Passenger\n\* `low-rise-passenger` - Low Rise Passenger\n\* `passenger` - Passenger\n\* `freight` - Freight'),zod.enum(['']),zod.literal(null)]).nullish(),
  "property": zod.object({
  "id": zod.string().uuid(),
  "createdAt": zod.string().datetime({"offset":true}),
  "updatedAt": zod.string().datetime({"offset":true}).nullable(),
  "name": zod.string(),
  "address": zod.object({
  "id": zod.number(),
  "raw": zod.string().max(usersCarsListResponsePropertyOneAddressOneRawMax),
  "formatted": zod.string().max(usersCarsListResponsePropertyOneAddressOneFormattedMax).optional(),
  "streetNumber": zod.string().max(usersCarsListResponsePropertyOneAddressOneStreetNumberMax).optional(),
  "street": zod.string(),
  "city": zod.string().nullable(),
  "postalCode": zod.string().nullable(),
  "state": zod.string().nullable(),
  "country": zod.string().nullable()
}).strict().nullable(),
  "region": zod.string().max(usersCarsListResponsePropertyOneRegionMax).nullish(),
  "clientId": zod.string().max(usersCarsListResponsePropertyOneClientIdMax).nullish(),
  "timeZone": zod.string().optional(),
  "lat": zod.number().nullable().default(usersCarsListResponsePropertyOneLatDefault),
  "lng": zod.number().nullable().default(usersCarsListResponsePropertyOneLngDefault),
  "propertyManager": zod.object({
  "id": zod.string().uuid(),
  "name": zod.string(),
  "owner": zod.object({
  "id": zod.string().uuid(),
  "username": zod.string().max(usersCarsListResponsePropertyOnePropertyManagerOneOwnerOneUsernameMax).regex(usersCarsListResponsePropertyOnePropertyManagerOneOwnerOneUsernameRegExp).describe('Required. 150 characters or fewer. Letters, digits and @\/.\/+\/-\/_ only.'),
  "email": zod.string().email().max(usersCarsListResponsePropertyOnePropertyManagerOneOwnerOneEmailMax).optional(),
  "phoneNumber": zod.string().max(usersCarsListResponsePropertyOnePropertyManagerOneOwnerOnePhoneNumberMax).optional(),
  "fullName": zod.string(),
  "consultantGroup": zod.string().nullable(),
  "clientGroup": zod.string().nullable(),
  "role": zod.union([zod.enum(['consultant', 'client', 'service_provider']).describe('\* `consultant` - consultant\n\* `client` - client\n\* `service_provider` - service_provider'),zod.literal(null)]).nullable(),
  "isLiftaiAdmin": zod.boolean(),
  "isGroupAdmin": zod.boolean()
}).strict().nullable()
}).strict().nullable(),
  "consultantGroup": zod.object({
  "name": zod.string(),
  "id": zod.string().uuid(),
  "owner": zod.object({
  "id": zod.string().uuid(),
  "username": zod.string().max(usersCarsListResponsePropertyOneConsultantGroupOneOwnerOneUsernameMax).regex(usersCarsListResponsePropertyOneConsultantGroupOneOwnerOneUsernameRegExp).describe('Required. 150 characters or fewer. Letters, digits and @\/.\/+\/-\/_ only.'),
  "fullName": zod.string(),
  "email": zod.string().email().max(usersCarsListResponsePropertyOneConsultantGroupOneOwnerOneEmailMax).optional(),
  "phoneNumber": zod.string().max(usersCarsListResponsePropertyOneConsultantGroupOneOwnerOnePhoneNumberMax).optional()
}).strict().nullable(),
  "consultants": zod.array(zod.object({
  "id": zod.string().uuid(),
  "username": zod.string().max(usersCarsListResponsePropertyOneConsultantGroupOneConsultantsItemUsernameMax).regex(usersCarsListResponsePropertyOneConsultantGroupOneConsultantsItemUsernameRegExp).describe('Required. 150 characters or fewer. Letters, digits and @\/.\/+\/-\/_ only.'),
  "fullName": zod.string(),
  "email": zod.string().email().max(usersCarsListResponsePropertyOneConsultantGroupOneConsultantsItemEmailMax).optional(),
  "phoneNumber": zod.string().max(usersCarsListResponsePropertyOneConsultantGroupOneConsultantsItemPhoneNumberMax).optional()
}).strict()),
  "file": zod.string().url().regex(usersCarsListResponsePropertyOneConsultantGroupOneFileRegExp).nullish()
}).strict().nullable(),
  "assignedConsultant": zod.object({
  "id": zod.string().uuid(),
  "username": zod.string().max(usersCarsListResponsePropertyOneAssignedConsultantOneUsernameMax).regex(usersCarsListResponsePropertyOneAssignedConsultantOneUsernameRegExp).describe('Required. 150 characters or fewer. Letters, digits and @\/.\/+\/-\/_ only.'),
  "email": zod.string().email().max(usersCarsListResponsePropertyOneAssignedConsultantOneEmailMax).optional(),
  "phoneNumber": zod.string().max(usersCarsListResponsePropertyOneAssignedConsultantOnePhoneNumberMax).optional(),
  "fullName": zod.string(),
  "consultantGroup": zod.string().nullable(),
  "clientGroup": zod.string().nullable(),
  "role": zod.union([zod.enum(['consultant', 'client', 'service_provider']).describe('\* `consultant` - consultant\n\* `client` - client\n\* `service_provider` - service_provider'),zod.literal(null)]).nullable(),
  "isLiftaiAdmin": zod.boolean(),
  "isGroupAdmin": zod.boolean()
}).strict().nullable(),
  "portfolio": zod.object({
  "id": zod.string().uuid(),
  "name": zod.string()
}).strict().nullable(),
  "unitCount": zod.number(),
  "buildingNumber": zod.string().max(usersCarsListResponsePropertyOneBuildingNumberMax).optional(),
  "contact": zod.object({
  "id": zod.string().uuid(),
  "name": zod.string().max(usersCarsListResponsePropertyOneContactOneNameMax),
  "email": zod.string().email().nullish(),
  "phone": zod.string().nullish(),
  "createdAt": zod.string().datetime({"offset":true}),
  "updatedAt": zod.string().datetime({"offset":true})
}).strict().nullish()
}).strict(),
  "serviceProviderId": zod.string().uuid().nullable(),
  "ahjId": zod.string().optional(),
  "criticalUnit": zod.boolean().optional(),
  "installationYear": zod.number().min(usersCarsListResponseInstallationYearMin).max(usersCarsListResponseInstallationYearMax).nullish(),
  "modernizationYear": zod.number().min(usersCarsListResponseModernizationYearMin).max(usersCarsListResponseModernizationYearMax).nullish(),
  "numEntrances": zod.number().min(usersCarsListResponseNumEntrancesMin).max(usersCarsListResponseNumEntrancesMax).nullish(),
  "speedFpm": zod.number().min(usersCarsListResponseSpeedFpmMin).max(usersCarsListResponseSpeedFpmMax).nullish(),
  "capacityLbs": zod.number().min(usersCarsListResponseCapacityLbsMin).max(usersCarsListResponseCapacityLbsMax).nullish(),
  "lastSspiTest": zod.string().date().nullish(),
  "lastCat1Test": zod.string().date().nullish(),
  "lastCat5Test": zod.string().date().nullish(),
  "driveType": zod.string().optional(),
  "controllerModel": zod.string().optional(),
  "oem": zod.string().uuid().nullable(),
  "manufacturer": zod.string().nullable(),
  "serviceProviderInternalId": zod.string().nullable()
}).strict().describe('A subclass of DRF\'s ModelSerializer which realizes when fields it is\nserializing are to related objects which also have NestableModelSerializers\ndefined for them and uses those serializers instead of the default\nModelSerializer that DRF would use.\n\nThis ModelSerializer takes an additional `fields` argument that\ncontrols which fields should be displayed.\nFor more information, refer to the documentation:\nhttps:\/\/www.django-rest-framework.org\/api-guide\/serializers\/#dynamically-modifying-fields\n\n\nExample:\nPortfolioSerializer(required=False, fields=[\"id\", \"name\"])')
export const UsersCarsListResponse = zod.array(UsersCarsListResponseItem)

/**
 * Adds a GET-only ``aggregate`` action to a viewset.
 *
 * The viewset must declare ``AGGREGATE_CONFIG: AggregateConfig`` and a
 * ``filterset_class``. GET-only because the chat loopback only issues GET.
 */
export const usersCarsCreatePathOwnerEmailRegExp = new RegExp('^[^/]+$');


export const UsersCarsCreateParams = zod.object({
  "ownerEmail": zod.string().regex(usersCarsCreatePathOwnerEmailRegExp)
})

export const usersCarsCreateBodyClientIdMax = 255;


export const usersCarsCreateBodyNumLandingsMin = 0;
export const usersCarsCreateBodyNumLandingsMax = 2147483647;

export const usersCarsCreateBodyInstallationYearMin = 0;
export const usersCarsCreateBodyInstallationYearMax = 2147483647;

export const usersCarsCreateBodyModernizationYearMin = 0;
export const usersCarsCreateBodyModernizationYearMax = 2147483647;

export const usersCarsCreateBodyNumEntrancesMin = 0;
export const usersCarsCreateBodyNumEntrancesMax = 2147483647;

export const usersCarsCreateBodySpeedFpmMin = 0;
export const usersCarsCreateBodySpeedFpmMax = 2147483647;

export const usersCarsCreateBodyCapacityLbsMin = 0;
export const usersCarsCreateBodyCapacityLbsMax = 2147483647;



export const UsersCarsCreateBody = zod.object({
  "clientId": zod.string().max(usersCarsCreateBodyClientIdMax).nullish(),
  "name": zod.string().min(1),
  "numLandings": zod.number().min(usersCarsCreateBodyNumLandingsMin).max(usersCarsCreateBodyNumLandingsMax).nullish(),
  "elevatorType": zod.union([zod.enum(['Traction', 'Hydro', 'Other', 'escalator', 'hydraulic-passenger', 'hydraulic-service', 'mrl-traction', 'geared-passenger', 'geared-traction', 'gearless-traction', 'gearless-passenger', 'wheelchair-lift', 'dumbwaiter', 'passenger-service', 'high-rise-passenger', 'low-rise-passenger', 'passenger', 'freight']).describe('\* `Traction` - Traction\n\* `Hydro` - Hydro\n\* `Other` - Other\n\* `escalator` - Escalator\n\* `hydraulic-passenger` - Hydraulic Passenger\n\* `hydraulic-service` - Hydraulic Service\n\* `mrl-traction` - MRL Traction\n\* `geared-passenger` - Geared Passenger\n\* `geared-traction` - Geared Traction\n\* `gearless-traction` - Gearless Traction\n\* `gearless-passenger` - Gearless Passenger\n\* `wheelchair-lift` - Wheelchair Lift\n\* `dumbwaiter` - Dumbwaiter\n\* `passenger-service` - Passenger\/Service\n\* `high-rise-passenger` - High Rise Passenger\n\* `low-rise-passenger` - Low Rise Passenger\n\* `passenger` - Passenger\n\* `freight` - Freight'),zod.enum(['']),zod.literal(null)]).nullish(),
  "ahjId": zod.string().optional(),
  "criticalUnit": zod.boolean().optional(),
  "installationYear": zod.number().min(usersCarsCreateBodyInstallationYearMin).max(usersCarsCreateBodyInstallationYearMax).nullish(),
  "modernizationYear": zod.number().min(usersCarsCreateBodyModernizationYearMin).max(usersCarsCreateBodyModernizationYearMax).nullish(),
  "numEntrances": zod.number().min(usersCarsCreateBodyNumEntrancesMin).max(usersCarsCreateBodyNumEntrancesMax).nullish(),
  "speedFpm": zod.number().min(usersCarsCreateBodySpeedFpmMin).max(usersCarsCreateBodySpeedFpmMax).nullish(),
  "capacityLbs": zod.number().min(usersCarsCreateBodyCapacityLbsMin).max(usersCarsCreateBodyCapacityLbsMax).nullish(),
  "lastSspiTest": zod.string().date().nullish(),
  "lastCat1Test": zod.string().date().nullish(),
  "lastCat5Test": zod.string().date().nullish(),
  "driveType": zod.string().optional(),
  "controllerModel": zod.string().optional(),
  "oem": zod.string().uuid().nullable()
}).describe('A subclass of DRF\'s ModelSerializer which realizes when fields it is\nserializing are to related objects which also have NestableModelSerializers\ndefined for them and uses those serializers instead of the default\nModelSerializer that DRF would use.\n\nThis ModelSerializer takes an additional `fields` argument that\ncontrols which fields should be displayed.\nFor more information, refer to the documentation:\nhttps:\/\/www.django-rest-framework.org\/api-guide\/serializers\/#dynamically-modifying-fields\n\n\nExample:\nPortfolioSerializer(required=False, fields=[\"id\", \"name\"])')

export const usersCarsCreateResponseClientIdMax = 255;

export const usersCarsCreateResponseNumLandingsMin = 0;
export const usersCarsCreateResponseNumLandingsMax = 2147483647;

export const usersCarsCreateResponsePropertyOneAddressOneRawMax = 200;

export const usersCarsCreateResponsePropertyOneAddressOneFormattedMax = 200;

export const usersCarsCreateResponsePropertyOneAddressOneStreetNumberMax = 20;

export const usersCarsCreateResponsePropertyOneRegionMax = 255;

export const usersCarsCreateResponsePropertyOneClientIdMax = 255;

export const usersCarsCreateResponsePropertyOneLatDefault = 0;
export const usersCarsCreateResponsePropertyOneLngDefault = 0;
export const usersCarsCreateResponsePropertyOnePropertyManagerOneOwnerOneUsernameMax = 150;


export const usersCarsCreateResponsePropertyOnePropertyManagerOneOwnerOneUsernameRegExp = new RegExp('^[\\w.@+-]+$');
export const usersCarsCreateResponsePropertyOnePropertyManagerOneOwnerOneEmailMax = 254;

export const usersCarsCreateResponsePropertyOnePropertyManagerOneOwnerOnePhoneNumberMax = 128;

export const usersCarsCreateResponsePropertyOneConsultantGroupOneOwnerOneUsernameMax = 150;


export const usersCarsCreateResponsePropertyOneConsultantGroupOneOwnerOneUsernameRegExp = new RegExp('^[\\w.@+-]+$');
export const usersCarsCreateResponsePropertyOneConsultantGroupOneOwnerOneEmailMax = 254;

export const usersCarsCreateResponsePropertyOneConsultantGroupOneOwnerOnePhoneNumberMax = 128;

export const usersCarsCreateResponsePropertyOneConsultantGroupOneConsultantsItemUsernameMax = 150;


export const usersCarsCreateResponsePropertyOneConsultantGroupOneConsultantsItemUsernameRegExp = new RegExp('^[\\w.@+-]+$');
export const usersCarsCreateResponsePropertyOneConsultantGroupOneConsultantsItemEmailMax = 254;

export const usersCarsCreateResponsePropertyOneConsultantGroupOneConsultantsItemPhoneNumberMax = 128;

export const usersCarsCreateResponsePropertyOneConsultantGroupOneFileRegExp = new RegExp('(?:jpg|png|jpeg)$');
export const usersCarsCreateResponsePropertyOneAssignedConsultantOneUsernameMax = 150;


export const usersCarsCreateResponsePropertyOneAssignedConsultantOneUsernameRegExp = new RegExp('^[\\w.@+-]+$');
export const usersCarsCreateResponsePropertyOneAssignedConsultantOneEmailMax = 254;

export const usersCarsCreateResponsePropertyOneAssignedConsultantOnePhoneNumberMax = 128;

export const usersCarsCreateResponsePropertyOneBuildingNumberMax = 255;

export const usersCarsCreateResponsePropertyOneContactOneNameMax = 255;

export const usersCarsCreateResponseInstallationYearMin = 0;
export const usersCarsCreateResponseInstallationYearMax = 2147483647;

export const usersCarsCreateResponseModernizationYearMin = 0;
export const usersCarsCreateResponseModernizationYearMax = 2147483647;

export const usersCarsCreateResponseNumEntrancesMin = 0;
export const usersCarsCreateResponseNumEntrancesMax = 2147483647;

export const usersCarsCreateResponseSpeedFpmMin = 0;
export const usersCarsCreateResponseSpeedFpmMax = 2147483647;

export const usersCarsCreateResponseCapacityLbsMin = 0;
export const usersCarsCreateResponseCapacityLbsMax = 2147483647;



export const UsersCarsCreateResponse = zod.object({
  "id": zod.string().uuid(),
  "clientId": zod.string().max(usersCarsCreateResponseClientIdMax).nullish(),
  "customerAccounts": zod.array(zod.object({
  "id": zod.string().uuid(),
  "name": zod.string()
}).strict().describe('A subclass of DRF\'s ModelSerializer which realizes when fields it is\nserializing are to related objects which also have NestableModelSerializers\ndefined for them and uses those serializers instead of the default\nModelSerializer that DRF would use.\n\nThis ModelSerializer takes an additional `fields` argument that\ncontrols which fields should be displayed.\nFor more information, refer to the documentation:\nhttps:\/\/www.django-rest-framework.org\/api-guide\/serializers\/#dynamically-modifying-fields\n\n\nExample:\nPortfolioSerializer(required=False, fields=[\"id\", \"name\"])')),
  "name": zod.string(),
  "status": zod.string(),
  "numLandings": zod.number().min(usersCarsCreateResponseNumLandingsMin).max(usersCarsCreateResponseNumLandingsMax).nullish(),
  "elevatorType": zod.union([zod.enum(['Traction', 'Hydro', 'Other', 'escalator', 'hydraulic-passenger', 'hydraulic-service', 'mrl-traction', 'geared-passenger', 'geared-traction', 'gearless-traction', 'gearless-passenger', 'wheelchair-lift', 'dumbwaiter', 'passenger-service', 'high-rise-passenger', 'low-rise-passenger', 'passenger', 'freight']).describe('\* `Traction` - Traction\n\* `Hydro` - Hydro\n\* `Other` - Other\n\* `escalator` - Escalator\n\* `hydraulic-passenger` - Hydraulic Passenger\n\* `hydraulic-service` - Hydraulic Service\n\* `mrl-traction` - MRL Traction\n\* `geared-passenger` - Geared Passenger\n\* `geared-traction` - Geared Traction\n\* `gearless-traction` - Gearless Traction\n\* `gearless-passenger` - Gearless Passenger\n\* `wheelchair-lift` - Wheelchair Lift\n\* `dumbwaiter` - Dumbwaiter\n\* `passenger-service` - Passenger\/Service\n\* `high-rise-passenger` - High Rise Passenger\n\* `low-rise-passenger` - Low Rise Passenger\n\* `passenger` - Passenger\n\* `freight` - Freight'),zod.enum(['']),zod.literal(null)]).nullish(),
  "property": zod.object({
  "id": zod.string().uuid(),
  "createdAt": zod.string().datetime({"offset":true}),
  "updatedAt": zod.string().datetime({"offset":true}).nullable(),
  "name": zod.string(),
  "address": zod.object({
  "id": zod.number(),
  "raw": zod.string().max(usersCarsCreateResponsePropertyOneAddressOneRawMax),
  "formatted": zod.string().max(usersCarsCreateResponsePropertyOneAddressOneFormattedMax).optional(),
  "streetNumber": zod.string().max(usersCarsCreateResponsePropertyOneAddressOneStreetNumberMax).optional(),
  "street": zod.string(),
  "city": zod.string().nullable(),
  "postalCode": zod.string().nullable(),
  "state": zod.string().nullable(),
  "country": zod.string().nullable()
}).strict().nullable(),
  "region": zod.string().max(usersCarsCreateResponsePropertyOneRegionMax).nullish(),
  "clientId": zod.string().max(usersCarsCreateResponsePropertyOneClientIdMax).nullish(),
  "timeZone": zod.string().optional(),
  "lat": zod.number().nullable().default(usersCarsCreateResponsePropertyOneLatDefault),
  "lng": zod.number().nullable().default(usersCarsCreateResponsePropertyOneLngDefault),
  "propertyManager": zod.object({
  "id": zod.string().uuid(),
  "name": zod.string(),
  "owner": zod.object({
  "id": zod.string().uuid(),
  "username": zod.string().max(usersCarsCreateResponsePropertyOnePropertyManagerOneOwnerOneUsernameMax).regex(usersCarsCreateResponsePropertyOnePropertyManagerOneOwnerOneUsernameRegExp).describe('Required. 150 characters or fewer. Letters, digits and @\/.\/+\/-\/_ only.'),
  "email": zod.string().email().max(usersCarsCreateResponsePropertyOnePropertyManagerOneOwnerOneEmailMax).optional(),
  "phoneNumber": zod.string().max(usersCarsCreateResponsePropertyOnePropertyManagerOneOwnerOnePhoneNumberMax).optional(),
  "fullName": zod.string(),
  "consultantGroup": zod.string().nullable(),
  "clientGroup": zod.string().nullable(),
  "role": zod.union([zod.enum(['consultant', 'client', 'service_provider']).describe('\* `consultant` - consultant\n\* `client` - client\n\* `service_provider` - service_provider'),zod.literal(null)]).nullable(),
  "isLiftaiAdmin": zod.boolean(),
  "isGroupAdmin": zod.boolean()
}).strict().nullable()
}).strict().nullable(),
  "consultantGroup": zod.object({
  "name": zod.string(),
  "id": zod.string().uuid(),
  "owner": zod.object({
  "id": zod.string().uuid(),
  "username": zod.string().max(usersCarsCreateResponsePropertyOneConsultantGroupOneOwnerOneUsernameMax).regex(usersCarsCreateResponsePropertyOneConsultantGroupOneOwnerOneUsernameRegExp).describe('Required. 150 characters or fewer. Letters, digits and @\/.\/+\/-\/_ only.'),
  "fullName": zod.string(),
  "email": zod.string().email().max(usersCarsCreateResponsePropertyOneConsultantGroupOneOwnerOneEmailMax).optional(),
  "phoneNumber": zod.string().max(usersCarsCreateResponsePropertyOneConsultantGroupOneOwnerOnePhoneNumberMax).optional()
}).strict().nullable(),
  "consultants": zod.array(zod.object({
  "id": zod.string().uuid(),
  "username": zod.string().max(usersCarsCreateResponsePropertyOneConsultantGroupOneConsultantsItemUsernameMax).regex(usersCarsCreateResponsePropertyOneConsultantGroupOneConsultantsItemUsernameRegExp).describe('Required. 150 characters or fewer. Letters, digits and @\/.\/+\/-\/_ only.'),
  "fullName": zod.string(),
  "email": zod.string().email().max(usersCarsCreateResponsePropertyOneConsultantGroupOneConsultantsItemEmailMax).optional(),
  "phoneNumber": zod.string().max(usersCarsCreateResponsePropertyOneConsultantGroupOneConsultantsItemPhoneNumberMax).optional()
}).strict()),
  "file": zod.string().url().regex(usersCarsCreateResponsePropertyOneConsultantGroupOneFileRegExp).nullish()
}).strict().nullable(),
  "assignedConsultant": zod.object({
  "id": zod.string().uuid(),
  "username": zod.string().max(usersCarsCreateResponsePropertyOneAssignedConsultantOneUsernameMax).regex(usersCarsCreateResponsePropertyOneAssignedConsultantOneUsernameRegExp).describe('Required. 150 characters or fewer. Letters, digits and @\/.\/+\/-\/_ only.'),
  "email": zod.string().email().max(usersCarsCreateResponsePropertyOneAssignedConsultantOneEmailMax).optional(),
  "phoneNumber": zod.string().max(usersCarsCreateResponsePropertyOneAssignedConsultantOnePhoneNumberMax).optional(),
  "fullName": zod.string(),
  "consultantGroup": zod.string().nullable(),
  "clientGroup": zod.string().nullable(),
  "role": zod.union([zod.enum(['consultant', 'client', 'service_provider']).describe('\* `consultant` - consultant\n\* `client` - client\n\* `service_provider` - service_provider'),zod.literal(null)]).nullable(),
  "isLiftaiAdmin": zod.boolean(),
  "isGroupAdmin": zod.boolean()
}).strict().nullable(),
  "portfolio": zod.object({
  "id": zod.string().uuid(),
  "name": zod.string()
}).strict().nullable(),
  "unitCount": zod.number(),
  "buildingNumber": zod.string().max(usersCarsCreateResponsePropertyOneBuildingNumberMax).optional(),
  "contact": zod.object({
  "id": zod.string().uuid(),
  "name": zod.string().max(usersCarsCreateResponsePropertyOneContactOneNameMax),
  "email": zod.string().email().nullish(),
  "phone": zod.string().nullish(),
  "createdAt": zod.string().datetime({"offset":true}),
  "updatedAt": zod.string().datetime({"offset":true})
}).strict().nullish()
}).strict(),
  "serviceProviderId": zod.string().uuid().nullable(),
  "ahjId": zod.string().optional(),
  "criticalUnit": zod.boolean().optional(),
  "installationYear": zod.number().min(usersCarsCreateResponseInstallationYearMin).max(usersCarsCreateResponseInstallationYearMax).nullish(),
  "modernizationYear": zod.number().min(usersCarsCreateResponseModernizationYearMin).max(usersCarsCreateResponseModernizationYearMax).nullish(),
  "numEntrances": zod.number().min(usersCarsCreateResponseNumEntrancesMin).max(usersCarsCreateResponseNumEntrancesMax).nullish(),
  "speedFpm": zod.number().min(usersCarsCreateResponseSpeedFpmMin).max(usersCarsCreateResponseSpeedFpmMax).nullish(),
  "capacityLbs": zod.number().min(usersCarsCreateResponseCapacityLbsMin).max(usersCarsCreateResponseCapacityLbsMax).nullish(),
  "lastSspiTest": zod.string().date().nullish(),
  "lastCat1Test": zod.string().date().nullish(),
  "lastCat5Test": zod.string().date().nullish(),
  "driveType": zod.string().optional(),
  "controllerModel": zod.string().optional(),
  "oem": zod.string().uuid().nullable(),
  "manufacturer": zod.string().nullable(),
  "serviceProviderInternalId": zod.string().nullable()
}).strict().describe('A subclass of DRF\'s ModelSerializer which realizes when fields it is\nserializing are to related objects which also have NestableModelSerializers\ndefined for them and uses those serializers instead of the default\nModelSerializer that DRF would use.\n\nThis ModelSerializer takes an additional `fields` argument that\ncontrols which fields should be displayed.\nFor more information, refer to the documentation:\nhttps:\/\/www.django-rest-framework.org\/api-guide\/serializers\/#dynamically-modifying-fields\n\n\nExample:\nPortfolioSerializer(required=False, fields=[\"id\", \"name\"])')

/**
 * Adds a GET-only ``aggregate`` action to a viewset.
 *
 * The viewset must declare ``AGGREGATE_CONFIG: AggregateConfig`` and a
 * ``filterset_class``. GET-only because the chat loopback only issues GET.
 */
export const usersCarsRetrievePathOwnerEmailRegExp = new RegExp('^[^/]+$');


export const UsersCarsRetrieveParams = zod.object({
  "id": zod.string().uuid().describe('A UUID string identifying this car.'),
  "ownerEmail": zod.string().regex(usersCarsRetrievePathOwnerEmailRegExp)
})

export const usersCarsRetrieveResponseClientIdMax = 255;

export const usersCarsRetrieveResponseNumLandingsMin = 0;
export const usersCarsRetrieveResponseNumLandingsMax = 2147483647;

export const usersCarsRetrieveResponsePropertyOneAddressOneRawMax = 200;

export const usersCarsRetrieveResponsePropertyOneAddressOneFormattedMax = 200;

export const usersCarsRetrieveResponsePropertyOneAddressOneStreetNumberMax = 20;

export const usersCarsRetrieveResponsePropertyOneRegionMax = 255;

export const usersCarsRetrieveResponsePropertyOneClientIdMax = 255;

export const usersCarsRetrieveResponsePropertyOneLatDefault = 0;
export const usersCarsRetrieveResponsePropertyOneLngDefault = 0;
export const usersCarsRetrieveResponsePropertyOnePropertyManagerOneOwnerOneUsernameMax = 150;


export const usersCarsRetrieveResponsePropertyOnePropertyManagerOneOwnerOneUsernameRegExp = new RegExp('^[\\w.@+-]+$');
export const usersCarsRetrieveResponsePropertyOnePropertyManagerOneOwnerOneEmailMax = 254;

export const usersCarsRetrieveResponsePropertyOnePropertyManagerOneOwnerOnePhoneNumberMax = 128;

export const usersCarsRetrieveResponsePropertyOneConsultantGroupOneOwnerOneUsernameMax = 150;


export const usersCarsRetrieveResponsePropertyOneConsultantGroupOneOwnerOneUsernameRegExp = new RegExp('^[\\w.@+-]+$');
export const usersCarsRetrieveResponsePropertyOneConsultantGroupOneOwnerOneEmailMax = 254;

export const usersCarsRetrieveResponsePropertyOneConsultantGroupOneOwnerOnePhoneNumberMax = 128;

export const usersCarsRetrieveResponsePropertyOneConsultantGroupOneConsultantsItemUsernameMax = 150;


export const usersCarsRetrieveResponsePropertyOneConsultantGroupOneConsultantsItemUsernameRegExp = new RegExp('^[\\w.@+-]+$');
export const usersCarsRetrieveResponsePropertyOneConsultantGroupOneConsultantsItemEmailMax = 254;

export const usersCarsRetrieveResponsePropertyOneConsultantGroupOneConsultantsItemPhoneNumberMax = 128;

export const usersCarsRetrieveResponsePropertyOneConsultantGroupOneFileRegExp = new RegExp('(?:jpg|png|jpeg)$');
export const usersCarsRetrieveResponsePropertyOneAssignedConsultantOneUsernameMax = 150;


export const usersCarsRetrieveResponsePropertyOneAssignedConsultantOneUsernameRegExp = new RegExp('^[\\w.@+-]+$');
export const usersCarsRetrieveResponsePropertyOneAssignedConsultantOneEmailMax = 254;

export const usersCarsRetrieveResponsePropertyOneAssignedConsultantOnePhoneNumberMax = 128;

export const usersCarsRetrieveResponsePropertyOneBuildingNumberMax = 255;

export const usersCarsRetrieveResponsePropertyOneContactOneNameMax = 255;

export const usersCarsRetrieveResponseInstallationYearMin = 0;
export const usersCarsRetrieveResponseInstallationYearMax = 2147483647;

export const usersCarsRetrieveResponseModernizationYearMin = 0;
export const usersCarsRetrieveResponseModernizationYearMax = 2147483647;

export const usersCarsRetrieveResponseNumEntrancesMin = 0;
export const usersCarsRetrieveResponseNumEntrancesMax = 2147483647;

export const usersCarsRetrieveResponseSpeedFpmMin = 0;
export const usersCarsRetrieveResponseSpeedFpmMax = 2147483647;

export const usersCarsRetrieveResponseCapacityLbsMin = 0;
export const usersCarsRetrieveResponseCapacityLbsMax = 2147483647;



export const UsersCarsRetrieveResponse = zod.object({
  "id": zod.string().uuid(),
  "clientId": zod.string().max(usersCarsRetrieveResponseClientIdMax).nullish(),
  "customerAccounts": zod.array(zod.object({
  "id": zod.string().uuid(),
  "name": zod.string()
}).strict().describe('A subclass of DRF\'s ModelSerializer which realizes when fields it is\nserializing are to related objects which also have NestableModelSerializers\ndefined for them and uses those serializers instead of the default\nModelSerializer that DRF would use.\n\nThis ModelSerializer takes an additional `fields` argument that\ncontrols which fields should be displayed.\nFor more information, refer to the documentation:\nhttps:\/\/www.django-rest-framework.org\/api-guide\/serializers\/#dynamically-modifying-fields\n\n\nExample:\nPortfolioSerializer(required=False, fields=[\"id\", \"name\"])')),
  "name": zod.string(),
  "status": zod.string(),
  "numLandings": zod.number().min(usersCarsRetrieveResponseNumLandingsMin).max(usersCarsRetrieveResponseNumLandingsMax).nullish(),
  "elevatorType": zod.union([zod.enum(['Traction', 'Hydro', 'Other', 'escalator', 'hydraulic-passenger', 'hydraulic-service', 'mrl-traction', 'geared-passenger', 'geared-traction', 'gearless-traction', 'gearless-passenger', 'wheelchair-lift', 'dumbwaiter', 'passenger-service', 'high-rise-passenger', 'low-rise-passenger', 'passenger', 'freight']).describe('\* `Traction` - Traction\n\* `Hydro` - Hydro\n\* `Other` - Other\n\* `escalator` - Escalator\n\* `hydraulic-passenger` - Hydraulic Passenger\n\* `hydraulic-service` - Hydraulic Service\n\* `mrl-traction` - MRL Traction\n\* `geared-passenger` - Geared Passenger\n\* `geared-traction` - Geared Traction\n\* `gearless-traction` - Gearless Traction\n\* `gearless-passenger` - Gearless Passenger\n\* `wheelchair-lift` - Wheelchair Lift\n\* `dumbwaiter` - Dumbwaiter\n\* `passenger-service` - Passenger\/Service\n\* `high-rise-passenger` - High Rise Passenger\n\* `low-rise-passenger` - Low Rise Passenger\n\* `passenger` - Passenger\n\* `freight` - Freight'),zod.enum(['']),zod.literal(null)]).nullish(),
  "property": zod.object({
  "id": zod.string().uuid(),
  "createdAt": zod.string().datetime({"offset":true}),
  "updatedAt": zod.string().datetime({"offset":true}).nullable(),
  "name": zod.string(),
  "address": zod.object({
  "id": zod.number(),
  "raw": zod.string().max(usersCarsRetrieveResponsePropertyOneAddressOneRawMax),
  "formatted": zod.string().max(usersCarsRetrieveResponsePropertyOneAddressOneFormattedMax).optional(),
  "streetNumber": zod.string().max(usersCarsRetrieveResponsePropertyOneAddressOneStreetNumberMax).optional(),
  "street": zod.string(),
  "city": zod.string().nullable(),
  "postalCode": zod.string().nullable(),
  "state": zod.string().nullable(),
  "country": zod.string().nullable()
}).strict().nullable(),
  "region": zod.string().max(usersCarsRetrieveResponsePropertyOneRegionMax).nullish(),
  "clientId": zod.string().max(usersCarsRetrieveResponsePropertyOneClientIdMax).nullish(),
  "timeZone": zod.string().optional(),
  "lat": zod.number().nullable().default(usersCarsRetrieveResponsePropertyOneLatDefault),
  "lng": zod.number().nullable().default(usersCarsRetrieveResponsePropertyOneLngDefault),
  "propertyManager": zod.object({
  "id": zod.string().uuid(),
  "name": zod.string(),
  "owner": zod.object({
  "id": zod.string().uuid(),
  "username": zod.string().max(usersCarsRetrieveResponsePropertyOnePropertyManagerOneOwnerOneUsernameMax).regex(usersCarsRetrieveResponsePropertyOnePropertyManagerOneOwnerOneUsernameRegExp).describe('Required. 150 characters or fewer. Letters, digits and @\/.\/+\/-\/_ only.'),
  "email": zod.string().email().max(usersCarsRetrieveResponsePropertyOnePropertyManagerOneOwnerOneEmailMax).optional(),
  "phoneNumber": zod.string().max(usersCarsRetrieveResponsePropertyOnePropertyManagerOneOwnerOnePhoneNumberMax).optional(),
  "fullName": zod.string(),
  "consultantGroup": zod.string().nullable(),
  "clientGroup": zod.string().nullable(),
  "role": zod.union([zod.enum(['consultant', 'client', 'service_provider']).describe('\* `consultant` - consultant\n\* `client` - client\n\* `service_provider` - service_provider'),zod.literal(null)]).nullable(),
  "isLiftaiAdmin": zod.boolean(),
  "isGroupAdmin": zod.boolean()
}).strict().nullable()
}).strict().nullable(),
  "consultantGroup": zod.object({
  "name": zod.string(),
  "id": zod.string().uuid(),
  "owner": zod.object({
  "id": zod.string().uuid(),
  "username": zod.string().max(usersCarsRetrieveResponsePropertyOneConsultantGroupOneOwnerOneUsernameMax).regex(usersCarsRetrieveResponsePropertyOneConsultantGroupOneOwnerOneUsernameRegExp).describe('Required. 150 characters or fewer. Letters, digits and @\/.\/+\/-\/_ only.'),
  "fullName": zod.string(),
  "email": zod.string().email().max(usersCarsRetrieveResponsePropertyOneConsultantGroupOneOwnerOneEmailMax).optional(),
  "phoneNumber": zod.string().max(usersCarsRetrieveResponsePropertyOneConsultantGroupOneOwnerOnePhoneNumberMax).optional()
}).strict().nullable(),
  "consultants": zod.array(zod.object({
  "id": zod.string().uuid(),
  "username": zod.string().max(usersCarsRetrieveResponsePropertyOneConsultantGroupOneConsultantsItemUsernameMax).regex(usersCarsRetrieveResponsePropertyOneConsultantGroupOneConsultantsItemUsernameRegExp).describe('Required. 150 characters or fewer. Letters, digits and @\/.\/+\/-\/_ only.'),
  "fullName": zod.string(),
  "email": zod.string().email().max(usersCarsRetrieveResponsePropertyOneConsultantGroupOneConsultantsItemEmailMax).optional(),
  "phoneNumber": zod.string().max(usersCarsRetrieveResponsePropertyOneConsultantGroupOneConsultantsItemPhoneNumberMax).optional()
}).strict()),
  "file": zod.string().url().regex(usersCarsRetrieveResponsePropertyOneConsultantGroupOneFileRegExp).nullish()
}).strict().nullable(),
  "assignedConsultant": zod.object({
  "id": zod.string().uuid(),
  "username": zod.string().max(usersCarsRetrieveResponsePropertyOneAssignedConsultantOneUsernameMax).regex(usersCarsRetrieveResponsePropertyOneAssignedConsultantOneUsernameRegExp).describe('Required. 150 characters or fewer. Letters, digits and @\/.\/+\/-\/_ only.'),
  "email": zod.string().email().max(usersCarsRetrieveResponsePropertyOneAssignedConsultantOneEmailMax).optional(),
  "phoneNumber": zod.string().max(usersCarsRetrieveResponsePropertyOneAssignedConsultantOnePhoneNumberMax).optional(),
  "fullName": zod.string(),
  "consultantGroup": zod.string().nullable(),
  "clientGroup": zod.string().nullable(),
  "role": zod.union([zod.enum(['consultant', 'client', 'service_provider']).describe('\* `consultant` - consultant\n\* `client` - client\n\* `service_provider` - service_provider'),zod.literal(null)]).nullable(),
  "isLiftaiAdmin": zod.boolean(),
  "isGroupAdmin": zod.boolean()
}).strict().nullable(),
  "portfolio": zod.object({
  "id": zod.string().uuid(),
  "name": zod.string()
}).strict().nullable(),
  "unitCount": zod.number(),
  "buildingNumber": zod.string().max(usersCarsRetrieveResponsePropertyOneBuildingNumberMax).optional(),
  "contact": zod.object({
  "id": zod.string().uuid(),
  "name": zod.string().max(usersCarsRetrieveResponsePropertyOneContactOneNameMax),
  "email": zod.string().email().nullish(),
  "phone": zod.string().nullish(),
  "createdAt": zod.string().datetime({"offset":true}),
  "updatedAt": zod.string().datetime({"offset":true})
}).strict().nullish()
}).strict(),
  "serviceProviderId": zod.string().uuid().nullable(),
  "ahjId": zod.string().optional(),
  "criticalUnit": zod.boolean().optional(),
  "installationYear": zod.number().min(usersCarsRetrieveResponseInstallationYearMin).max(usersCarsRetrieveResponseInstallationYearMax).nullish(),
  "modernizationYear": zod.number().min(usersCarsRetrieveResponseModernizationYearMin).max(usersCarsRetrieveResponseModernizationYearMax).nullish(),
  "numEntrances": zod.number().min(usersCarsRetrieveResponseNumEntrancesMin).max(usersCarsRetrieveResponseNumEntrancesMax).nullish(),
  "speedFpm": zod.number().min(usersCarsRetrieveResponseSpeedFpmMin).max(usersCarsRetrieveResponseSpeedFpmMax).nullish(),
  "capacityLbs": zod.number().min(usersCarsRetrieveResponseCapacityLbsMin).max(usersCarsRetrieveResponseCapacityLbsMax).nullish(),
  "lastSspiTest": zod.string().date().nullish(),
  "lastCat1Test": zod.string().date().nullish(),
  "lastCat5Test": zod.string().date().nullish(),
  "driveType": zod.string().optional(),
  "controllerModel": zod.string().optional(),
  "oem": zod.string().uuid().nullable(),
  "manufacturer": zod.string().nullable(),
  "serviceProviderInternalId": zod.string().nullable()
}).strict().describe('A subclass of DRF\'s ModelSerializer which realizes when fields it is\nserializing are to related objects which also have NestableModelSerializers\ndefined for them and uses those serializers instead of the default\nModelSerializer that DRF would use.\n\nThis ModelSerializer takes an additional `fields` argument that\ncontrols which fields should be displayed.\nFor more information, refer to the documentation:\nhttps:\/\/www.django-rest-framework.org\/api-guide\/serializers\/#dynamically-modifying-fields\n\n\nExample:\nPortfolioSerializer(required=False, fields=[\"id\", \"name\"])')

/**
 * Adds a GET-only ``aggregate`` action to a viewset.
 *
 * The viewset must declare ``AGGREGATE_CONFIG: AggregateConfig`` and a
 * ``filterset_class``. GET-only because the chat loopback only issues GET.
 */
export const usersCarsUpdatePathOwnerEmailRegExp = new RegExp('^[^/]+$');


export const UsersCarsUpdateParams = zod.object({
  "id": zod.string().uuid().describe('A UUID string identifying this car.'),
  "ownerEmail": zod.string().regex(usersCarsUpdatePathOwnerEmailRegExp)
})

export const usersCarsUpdateBodyClientIdMax = 255;


export const usersCarsUpdateBodyNumLandingsMin = 0;
export const usersCarsUpdateBodyNumLandingsMax = 2147483647;

export const usersCarsUpdateBodyInstallationYearMin = 0;
export const usersCarsUpdateBodyInstallationYearMax = 2147483647;

export const usersCarsUpdateBodyModernizationYearMin = 0;
export const usersCarsUpdateBodyModernizationYearMax = 2147483647;

export const usersCarsUpdateBodyNumEntrancesMin = 0;
export const usersCarsUpdateBodyNumEntrancesMax = 2147483647;

export const usersCarsUpdateBodySpeedFpmMin = 0;
export const usersCarsUpdateBodySpeedFpmMax = 2147483647;

export const usersCarsUpdateBodyCapacityLbsMin = 0;
export const usersCarsUpdateBodyCapacityLbsMax = 2147483647;



export const UsersCarsUpdateBody = zod.object({
  "clientId": zod.string().max(usersCarsUpdateBodyClientIdMax).nullish(),
  "name": zod.string().min(1),
  "numLandings": zod.number().min(usersCarsUpdateBodyNumLandingsMin).max(usersCarsUpdateBodyNumLandingsMax).nullish(),
  "elevatorType": zod.union([zod.enum(['Traction', 'Hydro', 'Other', 'escalator', 'hydraulic-passenger', 'hydraulic-service', 'mrl-traction', 'geared-passenger', 'geared-traction', 'gearless-traction', 'gearless-passenger', 'wheelchair-lift', 'dumbwaiter', 'passenger-service', 'high-rise-passenger', 'low-rise-passenger', 'passenger', 'freight']).describe('\* `Traction` - Traction\n\* `Hydro` - Hydro\n\* `Other` - Other\n\* `escalator` - Escalator\n\* `hydraulic-passenger` - Hydraulic Passenger\n\* `hydraulic-service` - Hydraulic Service\n\* `mrl-traction` - MRL Traction\n\* `geared-passenger` - Geared Passenger\n\* `geared-traction` - Geared Traction\n\* `gearless-traction` - Gearless Traction\n\* `gearless-passenger` - Gearless Passenger\n\* `wheelchair-lift` - Wheelchair Lift\n\* `dumbwaiter` - Dumbwaiter\n\* `passenger-service` - Passenger\/Service\n\* `high-rise-passenger` - High Rise Passenger\n\* `low-rise-passenger` - Low Rise Passenger\n\* `passenger` - Passenger\n\* `freight` - Freight'),zod.enum(['']),zod.literal(null)]).nullish(),
  "ahjId": zod.string().optional(),
  "criticalUnit": zod.boolean().optional(),
  "installationYear": zod.number().min(usersCarsUpdateBodyInstallationYearMin).max(usersCarsUpdateBodyInstallationYearMax).nullish(),
  "modernizationYear": zod.number().min(usersCarsUpdateBodyModernizationYearMin).max(usersCarsUpdateBodyModernizationYearMax).nullish(),
  "numEntrances": zod.number().min(usersCarsUpdateBodyNumEntrancesMin).max(usersCarsUpdateBodyNumEntrancesMax).nullish(),
  "speedFpm": zod.number().min(usersCarsUpdateBodySpeedFpmMin).max(usersCarsUpdateBodySpeedFpmMax).nullish(),
  "capacityLbs": zod.number().min(usersCarsUpdateBodyCapacityLbsMin).max(usersCarsUpdateBodyCapacityLbsMax).nullish(),
  "lastSspiTest": zod.string().date().nullish(),
  "lastCat1Test": zod.string().date().nullish(),
  "lastCat5Test": zod.string().date().nullish(),
  "driveType": zod.string().optional(),
  "controllerModel": zod.string().optional(),
  "oem": zod.string().uuid().nullable()
}).describe('A subclass of DRF\'s ModelSerializer which realizes when fields it is\nserializing are to related objects which also have NestableModelSerializers\ndefined for them and uses those serializers instead of the default\nModelSerializer that DRF would use.\n\nThis ModelSerializer takes an additional `fields` argument that\ncontrols which fields should be displayed.\nFor more information, refer to the documentation:\nhttps:\/\/www.django-rest-framework.org\/api-guide\/serializers\/#dynamically-modifying-fields\n\n\nExample:\nPortfolioSerializer(required=False, fields=[\"id\", \"name\"])')

export const usersCarsUpdateResponseClientIdMax = 255;

export const usersCarsUpdateResponseNumLandingsMin = 0;
export const usersCarsUpdateResponseNumLandingsMax = 2147483647;

export const usersCarsUpdateResponsePropertyOneAddressOneRawMax = 200;

export const usersCarsUpdateResponsePropertyOneAddressOneFormattedMax = 200;

export const usersCarsUpdateResponsePropertyOneAddressOneStreetNumberMax = 20;

export const usersCarsUpdateResponsePropertyOneRegionMax = 255;

export const usersCarsUpdateResponsePropertyOneClientIdMax = 255;

export const usersCarsUpdateResponsePropertyOneLatDefault = 0;
export const usersCarsUpdateResponsePropertyOneLngDefault = 0;
export const usersCarsUpdateResponsePropertyOnePropertyManagerOneOwnerOneUsernameMax = 150;


export const usersCarsUpdateResponsePropertyOnePropertyManagerOneOwnerOneUsernameRegExp = new RegExp('^[\\w.@+-]+$');
export const usersCarsUpdateResponsePropertyOnePropertyManagerOneOwnerOneEmailMax = 254;

export const usersCarsUpdateResponsePropertyOnePropertyManagerOneOwnerOnePhoneNumberMax = 128;

export const usersCarsUpdateResponsePropertyOneConsultantGroupOneOwnerOneUsernameMax = 150;


export const usersCarsUpdateResponsePropertyOneConsultantGroupOneOwnerOneUsernameRegExp = new RegExp('^[\\w.@+-]+$');
export const usersCarsUpdateResponsePropertyOneConsultantGroupOneOwnerOneEmailMax = 254;

export const usersCarsUpdateResponsePropertyOneConsultantGroupOneOwnerOnePhoneNumberMax = 128;

export const usersCarsUpdateResponsePropertyOneConsultantGroupOneConsultantsItemUsernameMax = 150;


export const usersCarsUpdateResponsePropertyOneConsultantGroupOneConsultantsItemUsernameRegExp = new RegExp('^[\\w.@+-]+$');
export const usersCarsUpdateResponsePropertyOneConsultantGroupOneConsultantsItemEmailMax = 254;

export const usersCarsUpdateResponsePropertyOneConsultantGroupOneConsultantsItemPhoneNumberMax = 128;

export const usersCarsUpdateResponsePropertyOneConsultantGroupOneFileRegExp = new RegExp('(?:jpg|png|jpeg)$');
export const usersCarsUpdateResponsePropertyOneAssignedConsultantOneUsernameMax = 150;


export const usersCarsUpdateResponsePropertyOneAssignedConsultantOneUsernameRegExp = new RegExp('^[\\w.@+-]+$');
export const usersCarsUpdateResponsePropertyOneAssignedConsultantOneEmailMax = 254;

export const usersCarsUpdateResponsePropertyOneAssignedConsultantOnePhoneNumberMax = 128;

export const usersCarsUpdateResponsePropertyOneBuildingNumberMax = 255;

export const usersCarsUpdateResponsePropertyOneContactOneNameMax = 255;

export const usersCarsUpdateResponseInstallationYearMin = 0;
export const usersCarsUpdateResponseInstallationYearMax = 2147483647;

export const usersCarsUpdateResponseModernizationYearMin = 0;
export const usersCarsUpdateResponseModernizationYearMax = 2147483647;

export const usersCarsUpdateResponseNumEntrancesMin = 0;
export const usersCarsUpdateResponseNumEntrancesMax = 2147483647;

export const usersCarsUpdateResponseSpeedFpmMin = 0;
export const usersCarsUpdateResponseSpeedFpmMax = 2147483647;

export const usersCarsUpdateResponseCapacityLbsMin = 0;
export const usersCarsUpdateResponseCapacityLbsMax = 2147483647;



export const UsersCarsUpdateResponse = zod.object({
  "id": zod.string().uuid(),
  "clientId": zod.string().max(usersCarsUpdateResponseClientIdMax).nullish(),
  "customerAccounts": zod.array(zod.object({
  "id": zod.string().uuid(),
  "name": zod.string()
}).strict().describe('A subclass of DRF\'s ModelSerializer which realizes when fields it is\nserializing are to related objects which also have NestableModelSerializers\ndefined for them and uses those serializers instead of the default\nModelSerializer that DRF would use.\n\nThis ModelSerializer takes an additional `fields` argument that\ncontrols which fields should be displayed.\nFor more information, refer to the documentation:\nhttps:\/\/www.django-rest-framework.org\/api-guide\/serializers\/#dynamically-modifying-fields\n\n\nExample:\nPortfolioSerializer(required=False, fields=[\"id\", \"name\"])')),
  "name": zod.string(),
  "status": zod.string(),
  "numLandings": zod.number().min(usersCarsUpdateResponseNumLandingsMin).max(usersCarsUpdateResponseNumLandingsMax).nullish(),
  "elevatorType": zod.union([zod.enum(['Traction', 'Hydro', 'Other', 'escalator', 'hydraulic-passenger', 'hydraulic-service', 'mrl-traction', 'geared-passenger', 'geared-traction', 'gearless-traction', 'gearless-passenger', 'wheelchair-lift', 'dumbwaiter', 'passenger-service', 'high-rise-passenger', 'low-rise-passenger', 'passenger', 'freight']).describe('\* `Traction` - Traction\n\* `Hydro` - Hydro\n\* `Other` - Other\n\* `escalator` - Escalator\n\* `hydraulic-passenger` - Hydraulic Passenger\n\* `hydraulic-service` - Hydraulic Service\n\* `mrl-traction` - MRL Traction\n\* `geared-passenger` - Geared Passenger\n\* `geared-traction` - Geared Traction\n\* `gearless-traction` - Gearless Traction\n\* `gearless-passenger` - Gearless Passenger\n\* `wheelchair-lift` - Wheelchair Lift\n\* `dumbwaiter` - Dumbwaiter\n\* `passenger-service` - Passenger\/Service\n\* `high-rise-passenger` - High Rise Passenger\n\* `low-rise-passenger` - Low Rise Passenger\n\* `passenger` - Passenger\n\* `freight` - Freight'),zod.enum(['']),zod.literal(null)]).nullish(),
  "property": zod.object({
  "id": zod.string().uuid(),
  "createdAt": zod.string().datetime({"offset":true}),
  "updatedAt": zod.string().datetime({"offset":true}).nullable(),
  "name": zod.string(),
  "address": zod.object({
  "id": zod.number(),
  "raw": zod.string().max(usersCarsUpdateResponsePropertyOneAddressOneRawMax),
  "formatted": zod.string().max(usersCarsUpdateResponsePropertyOneAddressOneFormattedMax).optional(),
  "streetNumber": zod.string().max(usersCarsUpdateResponsePropertyOneAddressOneStreetNumberMax).optional(),
  "street": zod.string(),
  "city": zod.string().nullable(),
  "postalCode": zod.string().nullable(),
  "state": zod.string().nullable(),
  "country": zod.string().nullable()
}).strict().nullable(),
  "region": zod.string().max(usersCarsUpdateResponsePropertyOneRegionMax).nullish(),
  "clientId": zod.string().max(usersCarsUpdateResponsePropertyOneClientIdMax).nullish(),
  "timeZone": zod.string().optional(),
  "lat": zod.number().nullable().default(usersCarsUpdateResponsePropertyOneLatDefault),
  "lng": zod.number().nullable().default(usersCarsUpdateResponsePropertyOneLngDefault),
  "propertyManager": zod.object({
  "id": zod.string().uuid(),
  "name": zod.string(),
  "owner": zod.object({
  "id": zod.string().uuid(),
  "username": zod.string().max(usersCarsUpdateResponsePropertyOnePropertyManagerOneOwnerOneUsernameMax).regex(usersCarsUpdateResponsePropertyOnePropertyManagerOneOwnerOneUsernameRegExp).describe('Required. 150 characters or fewer. Letters, digits and @\/.\/+\/-\/_ only.'),
  "email": zod.string().email().max(usersCarsUpdateResponsePropertyOnePropertyManagerOneOwnerOneEmailMax).optional(),
  "phoneNumber": zod.string().max(usersCarsUpdateResponsePropertyOnePropertyManagerOneOwnerOnePhoneNumberMax).optional(),
  "fullName": zod.string(),
  "consultantGroup": zod.string().nullable(),
  "clientGroup": zod.string().nullable(),
  "role": zod.union([zod.enum(['consultant', 'client', 'service_provider']).describe('\* `consultant` - consultant\n\* `client` - client\n\* `service_provider` - service_provider'),zod.literal(null)]).nullable(),
  "isLiftaiAdmin": zod.boolean(),
  "isGroupAdmin": zod.boolean()
}).strict().nullable()
}).strict().nullable(),
  "consultantGroup": zod.object({
  "name": zod.string(),
  "id": zod.string().uuid(),
  "owner": zod.object({
  "id": zod.string().uuid(),
  "username": zod.string().max(usersCarsUpdateResponsePropertyOneConsultantGroupOneOwnerOneUsernameMax).regex(usersCarsUpdateResponsePropertyOneConsultantGroupOneOwnerOneUsernameRegExp).describe('Required. 150 characters or fewer. Letters, digits and @\/.\/+\/-\/_ only.'),
  "fullName": zod.string(),
  "email": zod.string().email().max(usersCarsUpdateResponsePropertyOneConsultantGroupOneOwnerOneEmailMax).optional(),
  "phoneNumber": zod.string().max(usersCarsUpdateResponsePropertyOneConsultantGroupOneOwnerOnePhoneNumberMax).optional()
}).strict().nullable(),
  "consultants": zod.array(zod.object({
  "id": zod.string().uuid(),
  "username": zod.string().max(usersCarsUpdateResponsePropertyOneConsultantGroupOneConsultantsItemUsernameMax).regex(usersCarsUpdateResponsePropertyOneConsultantGroupOneConsultantsItemUsernameRegExp).describe('Required. 150 characters or fewer. Letters, digits and @\/.\/+\/-\/_ only.'),
  "fullName": zod.string(),
  "email": zod.string().email().max(usersCarsUpdateResponsePropertyOneConsultantGroupOneConsultantsItemEmailMax).optional(),
  "phoneNumber": zod.string().max(usersCarsUpdateResponsePropertyOneConsultantGroupOneConsultantsItemPhoneNumberMax).optional()
}).strict()),
  "file": zod.string().url().regex(usersCarsUpdateResponsePropertyOneConsultantGroupOneFileRegExp).nullish()
}).strict().nullable(),
  "assignedConsultant": zod.object({
  "id": zod.string().uuid(),
  "username": zod.string().max(usersCarsUpdateResponsePropertyOneAssignedConsultantOneUsernameMax).regex(usersCarsUpdateResponsePropertyOneAssignedConsultantOneUsernameRegExp).describe('Required. 150 characters or fewer. Letters, digits and @\/.\/+\/-\/_ only.'),
  "email": zod.string().email().max(usersCarsUpdateResponsePropertyOneAssignedConsultantOneEmailMax).optional(),
  "phoneNumber": zod.string().max(usersCarsUpdateResponsePropertyOneAssignedConsultantOnePhoneNumberMax).optional(),
  "fullName": zod.string(),
  "consultantGroup": zod.string().nullable(),
  "clientGroup": zod.string().nullable(),
  "role": zod.union([zod.enum(['consultant', 'client', 'service_provider']).describe('\* `consultant` - consultant\n\* `client` - client\n\* `service_provider` - service_provider'),zod.literal(null)]).nullable(),
  "isLiftaiAdmin": zod.boolean(),
  "isGroupAdmin": zod.boolean()
}).strict().nullable(),
  "portfolio": zod.object({
  "id": zod.string().uuid(),
  "name": zod.string()
}).strict().nullable(),
  "unitCount": zod.number(),
  "buildingNumber": zod.string().max(usersCarsUpdateResponsePropertyOneBuildingNumberMax).optional(),
  "contact": zod.object({
  "id": zod.string().uuid(),
  "name": zod.string().max(usersCarsUpdateResponsePropertyOneContactOneNameMax),
  "email": zod.string().email().nullish(),
  "phone": zod.string().nullish(),
  "createdAt": zod.string().datetime({"offset":true}),
  "updatedAt": zod.string().datetime({"offset":true})
}).strict().nullish()
}).strict(),
  "serviceProviderId": zod.string().uuid().nullable(),
  "ahjId": zod.string().optional(),
  "criticalUnit": zod.boolean().optional(),
  "installationYear": zod.number().min(usersCarsUpdateResponseInstallationYearMin).max(usersCarsUpdateResponseInstallationYearMax).nullish(),
  "modernizationYear": zod.number().min(usersCarsUpdateResponseModernizationYearMin).max(usersCarsUpdateResponseModernizationYearMax).nullish(),
  "numEntrances": zod.number().min(usersCarsUpdateResponseNumEntrancesMin).max(usersCarsUpdateResponseNumEntrancesMax).nullish(),
  "speedFpm": zod.number().min(usersCarsUpdateResponseSpeedFpmMin).max(usersCarsUpdateResponseSpeedFpmMax).nullish(),
  "capacityLbs": zod.number().min(usersCarsUpdateResponseCapacityLbsMin).max(usersCarsUpdateResponseCapacityLbsMax).nullish(),
  "lastSspiTest": zod.string().date().nullish(),
  "lastCat1Test": zod.string().date().nullish(),
  "lastCat5Test": zod.string().date().nullish(),
  "driveType": zod.string().optional(),
  "controllerModel": zod.string().optional(),
  "oem": zod.string().uuid().nullable(),
  "manufacturer": zod.string().nullable(),
  "serviceProviderInternalId": zod.string().nullable()
}).strict().describe('A subclass of DRF\'s ModelSerializer which realizes when fields it is\nserializing are to related objects which also have NestableModelSerializers\ndefined for them and uses those serializers instead of the default\nModelSerializer that DRF would use.\n\nThis ModelSerializer takes an additional `fields` argument that\ncontrols which fields should be displayed.\nFor more information, refer to the documentation:\nhttps:\/\/www.django-rest-framework.org\/api-guide\/serializers\/#dynamically-modifying-fields\n\n\nExample:\nPortfolioSerializer(required=False, fields=[\"id\", \"name\"])')

/**
 * Adds a GET-only ``aggregate`` action to a viewset.
 *
 * The viewset must declare ``AGGREGATE_CONFIG: AggregateConfig`` and a
 * ``filterset_class``. GET-only because the chat loopback only issues GET.
 */
export const usersCarsPartialUpdatePathOwnerEmailRegExp = new RegExp('^[^/]+$');


export const UsersCarsPartialUpdateParams = zod.object({
  "id": zod.string().uuid().describe('A UUID string identifying this car.'),
  "ownerEmail": zod.string().regex(usersCarsPartialUpdatePathOwnerEmailRegExp)
})

export const usersCarsPartialUpdateBodyClientIdMax = 255;


export const usersCarsPartialUpdateBodyNumLandingsMin = 0;
export const usersCarsPartialUpdateBodyNumLandingsMax = 2147483647;

export const usersCarsPartialUpdateBodyInstallationYearMin = 0;
export const usersCarsPartialUpdateBodyInstallationYearMax = 2147483647;

export const usersCarsPartialUpdateBodyModernizationYearMin = 0;
export const usersCarsPartialUpdateBodyModernizationYearMax = 2147483647;

export const usersCarsPartialUpdateBodyNumEntrancesMin = 0;
export const usersCarsPartialUpdateBodyNumEntrancesMax = 2147483647;

export const usersCarsPartialUpdateBodySpeedFpmMin = 0;
export const usersCarsPartialUpdateBodySpeedFpmMax = 2147483647;

export const usersCarsPartialUpdateBodyCapacityLbsMin = 0;
export const usersCarsPartialUpdateBodyCapacityLbsMax = 2147483647;



export const UsersCarsPartialUpdateBody = zod.object({
  "clientId": zod.string().max(usersCarsPartialUpdateBodyClientIdMax).nullish(),
  "name": zod.string().min(1).optional(),
  "numLandings": zod.number().min(usersCarsPartialUpdateBodyNumLandingsMin).max(usersCarsPartialUpdateBodyNumLandingsMax).nullish(),
  "elevatorType": zod.union([zod.enum(['Traction', 'Hydro', 'Other', 'escalator', 'hydraulic-passenger', 'hydraulic-service', 'mrl-traction', 'geared-passenger', 'geared-traction', 'gearless-traction', 'gearless-passenger', 'wheelchair-lift', 'dumbwaiter', 'passenger-service', 'high-rise-passenger', 'low-rise-passenger', 'passenger', 'freight']).describe('\* `Traction` - Traction\n\* `Hydro` - Hydro\n\* `Other` - Other\n\* `escalator` - Escalator\n\* `hydraulic-passenger` - Hydraulic Passenger\n\* `hydraulic-service` - Hydraulic Service\n\* `mrl-traction` - MRL Traction\n\* `geared-passenger` - Geared Passenger\n\* `geared-traction` - Geared Traction\n\* `gearless-traction` - Gearless Traction\n\* `gearless-passenger` - Gearless Passenger\n\* `wheelchair-lift` - Wheelchair Lift\n\* `dumbwaiter` - Dumbwaiter\n\* `passenger-service` - Passenger\/Service\n\* `high-rise-passenger` - High Rise Passenger\n\* `low-rise-passenger` - Low Rise Passenger\n\* `passenger` - Passenger\n\* `freight` - Freight'),zod.enum(['']),zod.literal(null)]).nullish(),
  "ahjId": zod.string().optional(),
  "criticalUnit": zod.boolean().optional(),
  "installationYear": zod.number().min(usersCarsPartialUpdateBodyInstallationYearMin).max(usersCarsPartialUpdateBodyInstallationYearMax).nullish(),
  "modernizationYear": zod.number().min(usersCarsPartialUpdateBodyModernizationYearMin).max(usersCarsPartialUpdateBodyModernizationYearMax).nullish(),
  "numEntrances": zod.number().min(usersCarsPartialUpdateBodyNumEntrancesMin).max(usersCarsPartialUpdateBodyNumEntrancesMax).nullish(),
  "speedFpm": zod.number().min(usersCarsPartialUpdateBodySpeedFpmMin).max(usersCarsPartialUpdateBodySpeedFpmMax).nullish(),
  "capacityLbs": zod.number().min(usersCarsPartialUpdateBodyCapacityLbsMin).max(usersCarsPartialUpdateBodyCapacityLbsMax).nullish(),
  "lastSspiTest": zod.string().date().nullish(),
  "lastCat1Test": zod.string().date().nullish(),
  "lastCat5Test": zod.string().date().nullish(),
  "driveType": zod.string().optional(),
  "controllerModel": zod.string().optional(),
  "oem": zod.string().uuid().nullish()
}).describe('A subclass of DRF\'s ModelSerializer which realizes when fields it is\nserializing are to related objects which also have NestableModelSerializers\ndefined for them and uses those serializers instead of the default\nModelSerializer that DRF would use.\n\nThis ModelSerializer takes an additional `fields` argument that\ncontrols which fields should be displayed.\nFor more information, refer to the documentation:\nhttps:\/\/www.django-rest-framework.org\/api-guide\/serializers\/#dynamically-modifying-fields\n\n\nExample:\nPortfolioSerializer(required=False, fields=[\"id\", \"name\"])')

export const usersCarsPartialUpdateResponseClientIdMax = 255;

export const usersCarsPartialUpdateResponseNumLandingsMin = 0;
export const usersCarsPartialUpdateResponseNumLandingsMax = 2147483647;

export const usersCarsPartialUpdateResponsePropertyOneAddressOneRawMax = 200;

export const usersCarsPartialUpdateResponsePropertyOneAddressOneFormattedMax = 200;

export const usersCarsPartialUpdateResponsePropertyOneAddressOneStreetNumberMax = 20;

export const usersCarsPartialUpdateResponsePropertyOneRegionMax = 255;

export const usersCarsPartialUpdateResponsePropertyOneClientIdMax = 255;

export const usersCarsPartialUpdateResponsePropertyOneLatDefault = 0;
export const usersCarsPartialUpdateResponsePropertyOneLngDefault = 0;
export const usersCarsPartialUpdateResponsePropertyOnePropertyManagerOneOwnerOneUsernameMax = 150;


export const usersCarsPartialUpdateResponsePropertyOnePropertyManagerOneOwnerOneUsernameRegExp = new RegExp('^[\\w.@+-]+$');
export const usersCarsPartialUpdateResponsePropertyOnePropertyManagerOneOwnerOneEmailMax = 254;

export const usersCarsPartialUpdateResponsePropertyOnePropertyManagerOneOwnerOnePhoneNumberMax = 128;

export const usersCarsPartialUpdateResponsePropertyOneConsultantGroupOneOwnerOneUsernameMax = 150;


export const usersCarsPartialUpdateResponsePropertyOneConsultantGroupOneOwnerOneUsernameRegExp = new RegExp('^[\\w.@+-]+$');
export const usersCarsPartialUpdateResponsePropertyOneConsultantGroupOneOwnerOneEmailMax = 254;

export const usersCarsPartialUpdateResponsePropertyOneConsultantGroupOneOwnerOnePhoneNumberMax = 128;

export const usersCarsPartialUpdateResponsePropertyOneConsultantGroupOneConsultantsItemUsernameMax = 150;


export const usersCarsPartialUpdateResponsePropertyOneConsultantGroupOneConsultantsItemUsernameRegExp = new RegExp('^[\\w.@+-]+$');
export const usersCarsPartialUpdateResponsePropertyOneConsultantGroupOneConsultantsItemEmailMax = 254;

export const usersCarsPartialUpdateResponsePropertyOneConsultantGroupOneConsultantsItemPhoneNumberMax = 128;

export const usersCarsPartialUpdateResponsePropertyOneConsultantGroupOneFileRegExp = new RegExp('(?:jpg|png|jpeg)$');
export const usersCarsPartialUpdateResponsePropertyOneAssignedConsultantOneUsernameMax = 150;


export const usersCarsPartialUpdateResponsePropertyOneAssignedConsultantOneUsernameRegExp = new RegExp('^[\\w.@+-]+$');
export const usersCarsPartialUpdateResponsePropertyOneAssignedConsultantOneEmailMax = 254;

export const usersCarsPartialUpdateResponsePropertyOneAssignedConsultantOnePhoneNumberMax = 128;

export const usersCarsPartialUpdateResponsePropertyOneBuildingNumberMax = 255;

export const usersCarsPartialUpdateResponsePropertyOneContactOneNameMax = 255;

export const usersCarsPartialUpdateResponseInstallationYearMin = 0;
export const usersCarsPartialUpdateResponseInstallationYearMax = 2147483647;

export const usersCarsPartialUpdateResponseModernizationYearMin = 0;
export const usersCarsPartialUpdateResponseModernizationYearMax = 2147483647;

export const usersCarsPartialUpdateResponseNumEntrancesMin = 0;
export const usersCarsPartialUpdateResponseNumEntrancesMax = 2147483647;

export const usersCarsPartialUpdateResponseSpeedFpmMin = 0;
export const usersCarsPartialUpdateResponseSpeedFpmMax = 2147483647;

export const usersCarsPartialUpdateResponseCapacityLbsMin = 0;
export const usersCarsPartialUpdateResponseCapacityLbsMax = 2147483647;



export const UsersCarsPartialUpdateResponse = zod.object({
  "id": zod.string().uuid(),
  "clientId": zod.string().max(usersCarsPartialUpdateResponseClientIdMax).nullish(),
  "customerAccounts": zod.array(zod.object({
  "id": zod.string().uuid(),
  "name": zod.string()
}).strict().describe('A subclass of DRF\'s ModelSerializer which realizes when fields it is\nserializing are to related objects which also have NestableModelSerializers\ndefined for them and uses those serializers instead of the default\nModelSerializer that DRF would use.\n\nThis ModelSerializer takes an additional `fields` argument that\ncontrols which fields should be displayed.\nFor more information, refer to the documentation:\nhttps:\/\/www.django-rest-framework.org\/api-guide\/serializers\/#dynamically-modifying-fields\n\n\nExample:\nPortfolioSerializer(required=False, fields=[\"id\", \"name\"])')),
  "name": zod.string(),
  "status": zod.string(),
  "numLandings": zod.number().min(usersCarsPartialUpdateResponseNumLandingsMin).max(usersCarsPartialUpdateResponseNumLandingsMax).nullish(),
  "elevatorType": zod.union([zod.enum(['Traction', 'Hydro', 'Other', 'escalator', 'hydraulic-passenger', 'hydraulic-service', 'mrl-traction', 'geared-passenger', 'geared-traction', 'gearless-traction', 'gearless-passenger', 'wheelchair-lift', 'dumbwaiter', 'passenger-service', 'high-rise-passenger', 'low-rise-passenger', 'passenger', 'freight']).describe('\* `Traction` - Traction\n\* `Hydro` - Hydro\n\* `Other` - Other\n\* `escalator` - Escalator\n\* `hydraulic-passenger` - Hydraulic Passenger\n\* `hydraulic-service` - Hydraulic Service\n\* `mrl-traction` - MRL Traction\n\* `geared-passenger` - Geared Passenger\n\* `geared-traction` - Geared Traction\n\* `gearless-traction` - Gearless Traction\n\* `gearless-passenger` - Gearless Passenger\n\* `wheelchair-lift` - Wheelchair Lift\n\* `dumbwaiter` - Dumbwaiter\n\* `passenger-service` - Passenger\/Service\n\* `high-rise-passenger` - High Rise Passenger\n\* `low-rise-passenger` - Low Rise Passenger\n\* `passenger` - Passenger\n\* `freight` - Freight'),zod.enum(['']),zod.literal(null)]).nullish(),
  "property": zod.object({
  "id": zod.string().uuid(),
  "createdAt": zod.string().datetime({"offset":true}),
  "updatedAt": zod.string().datetime({"offset":true}).nullable(),
  "name": zod.string(),
  "address": zod.object({
  "id": zod.number(),
  "raw": zod.string().max(usersCarsPartialUpdateResponsePropertyOneAddressOneRawMax),
  "formatted": zod.string().max(usersCarsPartialUpdateResponsePropertyOneAddressOneFormattedMax).optional(),
  "streetNumber": zod.string().max(usersCarsPartialUpdateResponsePropertyOneAddressOneStreetNumberMax).optional(),
  "street": zod.string(),
  "city": zod.string().nullable(),
  "postalCode": zod.string().nullable(),
  "state": zod.string().nullable(),
  "country": zod.string().nullable()
}).strict().nullable(),
  "region": zod.string().max(usersCarsPartialUpdateResponsePropertyOneRegionMax).nullish(),
  "clientId": zod.string().max(usersCarsPartialUpdateResponsePropertyOneClientIdMax).nullish(),
  "timeZone": zod.string().optional(),
  "lat": zod.number().nullable().default(usersCarsPartialUpdateResponsePropertyOneLatDefault),
  "lng": zod.number().nullable().default(usersCarsPartialUpdateResponsePropertyOneLngDefault),
  "propertyManager": zod.object({
  "id": zod.string().uuid(),
  "name": zod.string(),
  "owner": zod.object({
  "id": zod.string().uuid(),
  "username": zod.string().max(usersCarsPartialUpdateResponsePropertyOnePropertyManagerOneOwnerOneUsernameMax).regex(usersCarsPartialUpdateResponsePropertyOnePropertyManagerOneOwnerOneUsernameRegExp).describe('Required. 150 characters or fewer. Letters, digits and @\/.\/+\/-\/_ only.'),
  "email": zod.string().email().max(usersCarsPartialUpdateResponsePropertyOnePropertyManagerOneOwnerOneEmailMax).optional(),
  "phoneNumber": zod.string().max(usersCarsPartialUpdateResponsePropertyOnePropertyManagerOneOwnerOnePhoneNumberMax).optional(),
  "fullName": zod.string(),
  "consultantGroup": zod.string().nullable(),
  "clientGroup": zod.string().nullable(),
  "role": zod.union([zod.enum(['consultant', 'client', 'service_provider']).describe('\* `consultant` - consultant\n\* `client` - client\n\* `service_provider` - service_provider'),zod.literal(null)]).nullable(),
  "isLiftaiAdmin": zod.boolean(),
  "isGroupAdmin": zod.boolean()
}).strict().nullable()
}).strict().nullable(),
  "consultantGroup": zod.object({
  "name": zod.string(),
  "id": zod.string().uuid(),
  "owner": zod.object({
  "id": zod.string().uuid(),
  "username": zod.string().max(usersCarsPartialUpdateResponsePropertyOneConsultantGroupOneOwnerOneUsernameMax).regex(usersCarsPartialUpdateResponsePropertyOneConsultantGroupOneOwnerOneUsernameRegExp).describe('Required. 150 characters or fewer. Letters, digits and @\/.\/+\/-\/_ only.'),
  "fullName": zod.string(),
  "email": zod.string().email().max(usersCarsPartialUpdateResponsePropertyOneConsultantGroupOneOwnerOneEmailMax).optional(),
  "phoneNumber": zod.string().max(usersCarsPartialUpdateResponsePropertyOneConsultantGroupOneOwnerOnePhoneNumberMax).optional()
}).strict().nullable(),
  "consultants": zod.array(zod.object({
  "id": zod.string().uuid(),
  "username": zod.string().max(usersCarsPartialUpdateResponsePropertyOneConsultantGroupOneConsultantsItemUsernameMax).regex(usersCarsPartialUpdateResponsePropertyOneConsultantGroupOneConsultantsItemUsernameRegExp).describe('Required. 150 characters or fewer. Letters, digits and @\/.\/+\/-\/_ only.'),
  "fullName": zod.string(),
  "email": zod.string().email().max(usersCarsPartialUpdateResponsePropertyOneConsultantGroupOneConsultantsItemEmailMax).optional(),
  "phoneNumber": zod.string().max(usersCarsPartialUpdateResponsePropertyOneConsultantGroupOneConsultantsItemPhoneNumberMax).optional()
}).strict()),
  "file": zod.string().url().regex(usersCarsPartialUpdateResponsePropertyOneConsultantGroupOneFileRegExp).nullish()
}).strict().nullable(),
  "assignedConsultant": zod.object({
  "id": zod.string().uuid(),
  "username": zod.string().max(usersCarsPartialUpdateResponsePropertyOneAssignedConsultantOneUsernameMax).regex(usersCarsPartialUpdateResponsePropertyOneAssignedConsultantOneUsernameRegExp).describe('Required. 150 characters or fewer. Letters, digits and @\/.\/+\/-\/_ only.'),
  "email": zod.string().email().max(usersCarsPartialUpdateResponsePropertyOneAssignedConsultantOneEmailMax).optional(),
  "phoneNumber": zod.string().max(usersCarsPartialUpdateResponsePropertyOneAssignedConsultantOnePhoneNumberMax).optional(),
  "fullName": zod.string(),
  "consultantGroup": zod.string().nullable(),
  "clientGroup": zod.string().nullable(),
  "role": zod.union([zod.enum(['consultant', 'client', 'service_provider']).describe('\* `consultant` - consultant\n\* `client` - client\n\* `service_provider` - service_provider'),zod.literal(null)]).nullable(),
  "isLiftaiAdmin": zod.boolean(),
  "isGroupAdmin": zod.boolean()
}).strict().nullable(),
  "portfolio": zod.object({
  "id": zod.string().uuid(),
  "name": zod.string()
}).strict().nullable(),
  "unitCount": zod.number(),
  "buildingNumber": zod.string().max(usersCarsPartialUpdateResponsePropertyOneBuildingNumberMax).optional(),
  "contact": zod.object({
  "id": zod.string().uuid(),
  "name": zod.string().max(usersCarsPartialUpdateResponsePropertyOneContactOneNameMax),
  "email": zod.string().email().nullish(),
  "phone": zod.string().nullish(),
  "createdAt": zod.string().datetime({"offset":true}),
  "updatedAt": zod.string().datetime({"offset":true})
}).strict().nullish()
}).strict(),
  "serviceProviderId": zod.string().uuid().nullable(),
  "ahjId": zod.string().optional(),
  "criticalUnit": zod.boolean().optional(),
  "installationYear": zod.number().min(usersCarsPartialUpdateResponseInstallationYearMin).max(usersCarsPartialUpdateResponseInstallationYearMax).nullish(),
  "modernizationYear": zod.number().min(usersCarsPartialUpdateResponseModernizationYearMin).max(usersCarsPartialUpdateResponseModernizationYearMax).nullish(),
  "numEntrances": zod.number().min(usersCarsPartialUpdateResponseNumEntrancesMin).max(usersCarsPartialUpdateResponseNumEntrancesMax).nullish(),
  "speedFpm": zod.number().min(usersCarsPartialUpdateResponseSpeedFpmMin).max(usersCarsPartialUpdateResponseSpeedFpmMax).nullish(),
  "capacityLbs": zod.number().min(usersCarsPartialUpdateResponseCapacityLbsMin).max(usersCarsPartialUpdateResponseCapacityLbsMax).nullish(),
  "lastSspiTest": zod.string().date().nullish(),
  "lastCat1Test": zod.string().date().nullish(),
  "lastCat5Test": zod.string().date().nullish(),
  "driveType": zod.string().optional(),
  "controllerModel": zod.string().optional(),
  "oem": zod.string().uuid().nullable(),
  "manufacturer": zod.string().nullable(),
  "serviceProviderInternalId": zod.string().nullable()
}).strict().describe('A subclass of DRF\'s ModelSerializer which realizes when fields it is\nserializing are to related objects which also have NestableModelSerializers\ndefined for them and uses those serializers instead of the default\nModelSerializer that DRF would use.\n\nThis ModelSerializer takes an additional `fields` argument that\ncontrols which fields should be displayed.\nFor more information, refer to the documentation:\nhttps:\/\/www.django-rest-framework.org\/api-guide\/serializers\/#dynamically-modifying-fields\n\n\nExample:\nPortfolioSerializer(required=False, fields=[\"id\", \"name\"])')

/**
 * Adds a GET-only ``aggregate`` action to a viewset.
 *
 * The viewset must declare ``AGGREGATE_CONFIG: AggregateConfig`` and a
 * ``filterset_class``. GET-only because the chat loopback only issues GET.
 */
export const usersCarsDestroyPathOwnerEmailRegExp = new RegExp('^[^/]+$');


export const UsersCarsDestroyParams = zod.object({
  "id": zod.string().uuid().describe('A UUID string identifying this car.'),
  "ownerEmail": zod.string().regex(usersCarsDestroyPathOwnerEmailRegExp)
})

export const UsersCarsDestroyResponse = zod.void()

/**
 * Get basic certificate information for a specific car.
 * URL: /api/v1/cars/{car_id}/certificates/
 */
export const usersCarsCertificatesListPathOwnerEmailRegExp = new RegExp('^[^/]+$');


export const UsersCarsCertificatesListParams = zod.object({
  "id": zod.string().uuid().describe('A UUID string identifying this car.'),
  "ownerEmail": zod.string().regex(usersCarsCertificatesListPathOwnerEmailRegExp)
})

export const UsersCarsCertificatesListQueryParams = zod.object({
  "client_id": zod.array(zod.string()).optional().describe('Multiple values may be separated by commas.'),
  "ordering": zod.array(zod.enum(['-name', 'name'])).optional().describe('Ordering\n\n\* `name` - Name\n\* `-name` - Name (descending)'),
  "portfolio_id": zod.string().uuid().optional(),
  "property_id": zod.string().uuid().optional(),
  "query": zod.string().optional(),
  "search_cars": zod.string().optional()
})

export const UsersCarsCertificatesListResponseItem = zod.object({
  "dateIssued": zod.string().date().describe('The date when the certificate was issued'),
  "expirationDate": zod.string().date().describe('The date when the certificate expires'),
  "downloadUrl": zod.string().nullable()
}).strict()
export const UsersCarsCertificatesListResponse = zod.array(UsersCarsCertificatesListResponseItem)

/**
 * Get compliance documents (certificates, inspection reports, violations,
 * and contracts) for a specific car.
 * URL: /api/v1/cars/{car_id}/compliance_documents/
 */
export const usersCarsComplianceDocumentsListPathOwnerEmailRegExp = new RegExp('^[^/]+$');


export const UsersCarsComplianceDocumentsListParams = zod.object({
  "id": zod.string().uuid().describe('A UUID string identifying this car.'),
  "ownerEmail": zod.string().regex(usersCarsComplianceDocumentsListPathOwnerEmailRegExp)
})

export const UsersCarsComplianceDocumentsListQueryParams = zod.object({
  "client_id": zod.array(zod.string()).optional().describe('Multiple values may be separated by commas.'),
  "ordering": zod.array(zod.enum(['-name', 'name'])).optional().describe('Ordering\n\n\* `name` - Name\n\* `-name` - Name (descending)'),
  "portfolio_id": zod.string().uuid().optional(),
  "property_id": zod.string().uuid().optional(),
  "query": zod.string().optional(),
  "search_cars": zod.string().optional()
})

export const UsersCarsComplianceDocumentsListResponseItem = zod.object({
  "dateIssued": zod.string().date().nullable(),
  "expirationDate": zod.string().date().nullable(),
  "downloadUrl": zod.string().nullable(),
  "documentType": zod.string()
}).strict().describe('One row of the ``compliance_documents`` action (certificate, inspection\nreport, violation or contract attachment).')
export const UsersCarsComplianceDocumentsListResponse = zod.array(UsersCarsComplianceDocumentsListResponseItem)

/**
 * Asset history: every record tagged to this car as a normalized,
 * date-sorted timeline (invoices, proposals, credits, tickets, violations,
 * inspection reports, certificates, and the governing contracts).
 *
 * URL: /api/v1/cars/{car_id}/history/
 * Optional ``?type=`` narrows which record types are returned. Access is
 * scoped by ``get_object`` (404 if the car is not visible to the caller),
 * so every sub-query is already limited to a car the caller may see.
 */
export const usersCarsHistoryListPathOwnerEmailRegExp = new RegExp('^[^/]+$');


export const UsersCarsHistoryListParams = zod.object({
  "id": zod.string().uuid().describe('A UUID string identifying this car.'),
  "ownerEmail": zod.string().regex(usersCarsHistoryListPathOwnerEmailRegExp)
})

export const UsersCarsHistoryListQueryParams = zod.object({
  "client_id": zod.array(zod.string()).optional().describe('Multiple values may be separated by commas.'),
  "ordering": zod.array(zod.enum(['-name', 'name'])).optional().describe('Ordering\n\n\* `name` - Name\n\* `-name` - Name (descending)'),
  "portfolio_id": zod.string().uuid().optional(),
  "property_id": zod.string().uuid().optional(),
  "query": zod.string().optional(),
  "search_cars": zod.string().optional(),
  "type": zod.string().optional().describe('Comma-separated record types to include (invoice, proposal, credit, ticket, violation, inspection_report, certificate, contract). Defaults to all types.')
})

export const usersCarsHistoryListResponseAmountRegExp = new RegExp('^-?\\d{0,10}(?:\\.\\d{0,2})?$');


export const UsersCarsHistoryListResponseItem = zod.object({
  "id": zod.string().uuid(),
  "type": zod.enum(['invoice', 'proposal', 'credit', 'ticket', 'violation', 'inspection_report', 'certificate', 'contract']).describe('\* `invoice` - invoice\n\* `proposal` - proposal\n\* `credit` - credit\n\* `ticket` - ticket\n\* `violation` - violation\n\* `inspection_report` - inspection_report\n\* `certificate` - certificate\n\* `contract` - contract'),
  "title": zod.string(),
  "subtitle": zod.string().nullable(),
  "amount": zod.string().regex(usersCarsHistoryListResponseAmountRegExp).nullable(),
  "eventDate": zod.string().date().nullable(),
  "status": zod.string().nullable(),
  "source": zod.object({
  "kind": zod.string(),
  "id": zod.string().uuid()
}).strict().describe('The underlying record a timeline row links out to.'),
  "isCoverage": zod.boolean()
}).strict().describe('One normalized row of the ``history`` action: an invoice, proposal,\nticket, violation, inspection report, certificate, or contract, reduced to\na common shape the timeline renders and sorts on.')
export const UsersCarsHistoryListResponse = zod.array(UsersCarsHistoryListResponseItem)

/**
 * Get basic violation information for a specific car.
 * URL: /api/v1/cars/{car_id}/violations/
 */
export const usersCarsViolationsRetrievePathOwnerEmailRegExp = new RegExp('^[^/]+$');


export const UsersCarsViolationsRetrieveParams = zod.object({
  "id": zod.string().uuid().describe('A UUID string identifying this car.'),
  "ownerEmail": zod.string().regex(usersCarsViolationsRetrievePathOwnerEmailRegExp)
})

export const usersCarsViolationsRetrieveResponseResultsItemCodeMax = 100;

export const usersCarsViolationsRetrieveResponseResultsItemLocationMax = 255;

export const usersCarsViolationsRetrieveResponseResultsItemCustomResolutionTypeMax = 100;



export const UsersCarsViolationsRetrieveResponse = zod.object({
  "statistics": zod.object({
  "open": zod.number(),
  "overdue": zod.number(),
  "resolved": zod.number(),
  "total": zod.number()
}).strict(),
  "results": zod.array(zod.object({
  "id": zod.string().uuid(),
  "code": zod.string().max(usersCarsViolationsRetrieveResponseResultsItemCodeMax).optional().describe('The violation code'),
  "severity": zod.union([zod.enum(['A', 'B', 'C']).describe('\* `A` - A (Urgent)\n\* `B` - B (Standard)\n\* `C` - C (Observation)'),zod.enum(['']),zod.literal(null)]).nullish().describe('LOLER defect category (A=urgent, B=standard, C=observation); null for US\/non-LOLER defects\n\n\* `A` - A (Urgent)\n\* `B` - B (Standard)\n\* `C` - C (Observation)'),
  "location": zod.string().max(usersCarsViolationsRetrieveResponseResultsItemLocationMax).nullish().describe('Where the violation was observed'),
  "dateOpen": zod.string().datetime({"offset":true}).describe('Date and time when the violation was first opened'),
  "correctionDue": zod.string().date().nullish().describe('The date by which the violation must be corrected. Optional only for LOLER category C defects, which carry no deadline; required for every other defect, including US ones (severity NULL).'),
  "createdAt": zod.string().datetime({"offset":true}),
  "resolvedDt": zod.string().datetime({"offset":true}).nullish().describe('When the violation was resolved (Leave blank for new violation)'),
  "status": zod.string(),
  "description": zod.string().describe('Detailed description of the violation'),
  "responsibility": zod.union([zod.enum(['county', 'owner', 'service_provider']).describe('\* `county` - County\n\* `owner` - Owner\n\* `service_provider` - Service Provider'),zod.enum(['']),zod.literal(null)]).nullish().describe('Who is responsible for correcting the violation\n\n\* `county` - County\n\* `owner` - Owner\n\* `service_provider` - Service Provider'),
  "noteCount": zod.number(),
  "affidavitDownloadUrl": zod.string().nullable(),
  "resolutionType": zod.union([zod.enum(['reinspection', 'waiver', 'affidavit', 'superseded', 'other']).describe('\* `reinspection` - Resolved by Reinspection\n\* `waiver` - Resolved by Waiver\n\* `affidavit` - Resolved by Affidavit\n\* `superseded` - Resolved by Supersession\n\* `other` - Other'),zod.enum(['']),zod.literal(null)]).nullish().describe('How the violation was resolved\n\n\* `reinspection` - Resolved by Reinspection\n\* `waiver` - Resolved by Waiver\n\* `affidavit` - Resolved by Affidavit\n\* `superseded` - Resolved by Supersession\n\* `other` - Other'),
  "customResolutionType": zod.string().max(usersCarsViolationsRetrieveResponseResultsItemCustomResolutionTypeMax).nullish().describe('Custom resolution type description when \'Other\' is selected')
}).strict())
}).strict().describe('The ``{statistics, results}`` envelope returned by the car violations\naction.')

/**
 * Adds a GET-only ``aggregate`` action to a viewset.
 *
 * The viewset must declare ``AGGREGATE_CONFIG: AggregateConfig`` and a
 * ``filterset_class``. GET-only because the chat loopback only issues GET.
 */
export const usersCarsAggregateRetrievePathOwnerEmailRegExp = new RegExp('^[^/]+$');


export const UsersCarsAggregateRetrieveParams = zod.object({
  "ownerEmail": zod.string().regex(usersCarsAggregateRetrievePathOwnerEmailRegExp)
})

export const UsersCarsAggregateRetrieveQueryParams = zod.object({
  "date_after": zod.string().date().optional().describe('Explicit start of the date range (inclusive).'),
  "date_before": zod.string().date().optional().describe('Explicit end of the date range (inclusive).'),
  "group_by": zod.string().optional().describe('Optional whitelisted group-by dimension (entity-specific, e.g. ``property``, ``portfolio``, ``entry_type``). Omit for a single scalar value; an unknown value returns 400 listing the valid dimensions.'),
  "limit": zod.number().optional().describe('Top-N rows for a grouped result, clamped to [1, 50]. Ignored for scalar results.'),
  "metric": zod.string().describe('Whitelisted metric to compute (entity-specific, e.g. ``invoice_amount``, ``ticket_count``, ``unit_count``). An unknown value returns 400 listing the entity\'s valid metrics.'),
  "period": zod.string().optional().describe('Named relative date range (one of ``30d``\/``90d``\/``ytd``\/``ttm``\/``all``\/``custom``) resolved into the entity\'s date filter. ``all`` applies no date bound at all. Routed to ``dropped_filters`` for entities without a date filter.')
})

export const UsersCarsAggregateRetrieveResponse = zod.union([zod.object({
  "entity": zod.string(),
  "metric": zod.string(),
  "value": zod.number().nullable(),
  "filtersApplied": zod.record(zod.string(), zod.unknown()),
  "droppedFilters": zod.record(zod.string(), zod.unknown())
}).strict().describe('Ungrouped aggregate: a single scalar ``value`` for the whole scope.'),zod.object({
  "entity": zod.string(),
  "metric": zod.string(),
  "groupBy": zod.string(),
  "rows": zod.array(zod.object({
  "group": zod.string().nullable(),
  "value": zod.number().nullable()
}).strict().describe('One row of a grouped aggregate: a display label and its metric value.')),
  "total": zod.number().nullable(),
  "groupCount": zod.number(),
  "shown": zod.number(),
  "truncated": zod.boolean(),
  "filtersApplied": zod.record(zod.string(), zod.unknown()),
  "droppedFilters": zod.record(zod.string(), zod.unknown())
}).strict().describe('Grouped aggregate: top-N rows plus the grand total and group count.')])

/**
 * Trimmed CarForm list for form dropdowns (SDK: carsFormList).
 *
 * Separate endpoint so the generated type is the precise CarForm shape;
 * the old ``?variant=form`` query param can't be typed per-value in OpenAPI.
 * Honors the same filters as the default list (e.g. property/portfolio).
 */
export const usersCarsFormListPathOwnerEmailRegExp = new RegExp('^[^/]+$');


export const UsersCarsFormListParams = zod.object({
  "ownerEmail": zod.string().regex(usersCarsFormListPathOwnerEmailRegExp)
})

export const UsersCarsFormListQueryParams = zod.object({
  "client_id": zod.array(zod.string()).optional().describe('Multiple values may be separated by commas.'),
  "ordering": zod.array(zod.enum(['-name', 'name'])).optional().describe('Ordering\n\n\* `name` - Name\n\* `-name` - Name (descending)'),
  "portfolio_id": zod.string().uuid().optional(),
  "property_id": zod.string().uuid().optional(),
  "query": zod.string().optional(),
  "search_cars": zod.string().optional()
})

export const usersCarsFormListResponsePropertyOneAddressOneRawMax = 200;

export const usersCarsFormListResponsePropertyOneAddressOneFormattedMax = 200;

export const usersCarsFormListResponsePropertyOneAddressOneStreetNumberMax = 20;

export const usersCarsFormListResponsePropertyOneRegionMax = 255;

export const usersCarsFormListResponsePropertyOneClientIdMax = 255;

export const usersCarsFormListResponsePropertyOneLatDefault = 0;
export const usersCarsFormListResponsePropertyOneLngDefault = 0;
export const usersCarsFormListResponsePropertyOnePropertyManagerOneOwnerOneUsernameMax = 150;


export const usersCarsFormListResponsePropertyOnePropertyManagerOneOwnerOneUsernameRegExp = new RegExp('^[\\w.@+-]+$');
export const usersCarsFormListResponsePropertyOnePropertyManagerOneOwnerOneEmailMax = 254;

export const usersCarsFormListResponsePropertyOnePropertyManagerOneOwnerOnePhoneNumberMax = 128;

export const usersCarsFormListResponsePropertyOneConsultantGroupOneOwnerOneUsernameMax = 150;


export const usersCarsFormListResponsePropertyOneConsultantGroupOneOwnerOneUsernameRegExp = new RegExp('^[\\w.@+-]+$');
export const usersCarsFormListResponsePropertyOneConsultantGroupOneOwnerOneEmailMax = 254;

export const usersCarsFormListResponsePropertyOneConsultantGroupOneOwnerOnePhoneNumberMax = 128;

export const usersCarsFormListResponsePropertyOneConsultantGroupOneConsultantsItemUsernameMax = 150;


export const usersCarsFormListResponsePropertyOneConsultantGroupOneConsultantsItemUsernameRegExp = new RegExp('^[\\w.@+-]+$');
export const usersCarsFormListResponsePropertyOneConsultantGroupOneConsultantsItemEmailMax = 254;

export const usersCarsFormListResponsePropertyOneConsultantGroupOneConsultantsItemPhoneNumberMax = 128;

export const usersCarsFormListResponsePropertyOneConsultantGroupOneFileRegExp = new RegExp('(?:jpg|png|jpeg)$');
export const usersCarsFormListResponsePropertyOneAssignedConsultantOneUsernameMax = 150;


export const usersCarsFormListResponsePropertyOneAssignedConsultantOneUsernameRegExp = new RegExp('^[\\w.@+-]+$');
export const usersCarsFormListResponsePropertyOneAssignedConsultantOneEmailMax = 254;

export const usersCarsFormListResponsePropertyOneAssignedConsultantOnePhoneNumberMax = 128;

export const usersCarsFormListResponsePropertyOneBuildingNumberMax = 255;

export const usersCarsFormListResponsePropertyOneContactOneNameMax = 255;



export const UsersCarsFormListResponseItem = zod.object({
  "id": zod.string().uuid(),
  "name": zod.string(),
  "property": zod.object({
  "id": zod.string().uuid(),
  "createdAt": zod.string().datetime({"offset":true}),
  "updatedAt": zod.string().datetime({"offset":true}).nullable(),
  "name": zod.string(),
  "address": zod.object({
  "id": zod.number(),
  "raw": zod.string().max(usersCarsFormListResponsePropertyOneAddressOneRawMax),
  "formatted": zod.string().max(usersCarsFormListResponsePropertyOneAddressOneFormattedMax).optional(),
  "streetNumber": zod.string().max(usersCarsFormListResponsePropertyOneAddressOneStreetNumberMax).optional(),
  "street": zod.string(),
  "city": zod.string().nullable(),
  "postalCode": zod.string().nullable(),
  "state": zod.string().nullable(),
  "country": zod.string().nullable()
}).strict().nullable(),
  "region": zod.string().max(usersCarsFormListResponsePropertyOneRegionMax).nullish(),
  "clientId": zod.string().max(usersCarsFormListResponsePropertyOneClientIdMax).nullish(),
  "timeZone": zod.string().optional(),
  "lat": zod.number().nullable().default(usersCarsFormListResponsePropertyOneLatDefault),
  "lng": zod.number().nullable().default(usersCarsFormListResponsePropertyOneLngDefault),
  "propertyManager": zod.object({
  "id": zod.string().uuid(),
  "name": zod.string(),
  "owner": zod.object({
  "id": zod.string().uuid(),
  "username": zod.string().max(usersCarsFormListResponsePropertyOnePropertyManagerOneOwnerOneUsernameMax).regex(usersCarsFormListResponsePropertyOnePropertyManagerOneOwnerOneUsernameRegExp).describe('Required. 150 characters or fewer. Letters, digits and @\/.\/+\/-\/_ only.'),
  "email": zod.string().email().max(usersCarsFormListResponsePropertyOnePropertyManagerOneOwnerOneEmailMax).optional(),
  "phoneNumber": zod.string().max(usersCarsFormListResponsePropertyOnePropertyManagerOneOwnerOnePhoneNumberMax).optional(),
  "fullName": zod.string(),
  "consultantGroup": zod.string().nullable(),
  "clientGroup": zod.string().nullable(),
  "role": zod.union([zod.enum(['consultant', 'client', 'service_provider']).describe('\* `consultant` - consultant\n\* `client` - client\n\* `service_provider` - service_provider'),zod.literal(null)]).nullable(),
  "isLiftaiAdmin": zod.boolean(),
  "isGroupAdmin": zod.boolean()
}).strict().nullable()
}).strict().nullable(),
  "consultantGroup": zod.object({
  "name": zod.string(),
  "id": zod.string().uuid(),
  "owner": zod.object({
  "id": zod.string().uuid(),
  "username": zod.string().max(usersCarsFormListResponsePropertyOneConsultantGroupOneOwnerOneUsernameMax).regex(usersCarsFormListResponsePropertyOneConsultantGroupOneOwnerOneUsernameRegExp).describe('Required. 150 characters or fewer. Letters, digits and @\/.\/+\/-\/_ only.'),
  "fullName": zod.string(),
  "email": zod.string().email().max(usersCarsFormListResponsePropertyOneConsultantGroupOneOwnerOneEmailMax).optional(),
  "phoneNumber": zod.string().max(usersCarsFormListResponsePropertyOneConsultantGroupOneOwnerOnePhoneNumberMax).optional()
}).strict().nullable(),
  "consultants": zod.array(zod.object({
  "id": zod.string().uuid(),
  "username": zod.string().max(usersCarsFormListResponsePropertyOneConsultantGroupOneConsultantsItemUsernameMax).regex(usersCarsFormListResponsePropertyOneConsultantGroupOneConsultantsItemUsernameRegExp).describe('Required. 150 characters or fewer. Letters, digits and @\/.\/+\/-\/_ only.'),
  "fullName": zod.string(),
  "email": zod.string().email().max(usersCarsFormListResponsePropertyOneConsultantGroupOneConsultantsItemEmailMax).optional(),
  "phoneNumber": zod.string().max(usersCarsFormListResponsePropertyOneConsultantGroupOneConsultantsItemPhoneNumberMax).optional()
}).strict()),
  "file": zod.string().url().regex(usersCarsFormListResponsePropertyOneConsultantGroupOneFileRegExp).nullish()
}).strict().nullable(),
  "assignedConsultant": zod.object({
  "id": zod.string().uuid(),
  "username": zod.string().max(usersCarsFormListResponsePropertyOneAssignedConsultantOneUsernameMax).regex(usersCarsFormListResponsePropertyOneAssignedConsultantOneUsernameRegExp).describe('Required. 150 characters or fewer. Letters, digits and @\/.\/+\/-\/_ only.'),
  "email": zod.string().email().max(usersCarsFormListResponsePropertyOneAssignedConsultantOneEmailMax).optional(),
  "phoneNumber": zod.string().max(usersCarsFormListResponsePropertyOneAssignedConsultantOnePhoneNumberMax).optional(),
  "fullName": zod.string(),
  "consultantGroup": zod.string().nullable(),
  "clientGroup": zod.string().nullable(),
  "role": zod.union([zod.enum(['consultant', 'client', 'service_provider']).describe('\* `consultant` - consultant\n\* `client` - client\n\* `service_provider` - service_provider'),zod.literal(null)]).nullable(),
  "isLiftaiAdmin": zod.boolean(),
  "isGroupAdmin": zod.boolean()
}).strict().nullable(),
  "portfolio": zod.object({
  "id": zod.string().uuid(),
  "name": zod.string()
}).strict().nullable(),
  "unitCount": zod.number(),
  "buildingNumber": zod.string().max(usersCarsFormListResponsePropertyOneBuildingNumberMax).optional(),
  "contact": zod.object({
  "id": zod.string().uuid(),
  "name": zod.string().max(usersCarsFormListResponsePropertyOneContactOneNameMax),
  "email": zod.string().email().nullish(),
  "phone": zod.string().nullish(),
  "createdAt": zod.string().datetime({"offset":true}),
  "updatedAt": zod.string().datetime({"offset":true})
}).strict().nullish()
}).strict()
}).strict().describe('A subclass of DRF\'s ModelSerializer which realizes when fields it is\nserializing are to related objects which also have NestableModelSerializers\ndefined for them and uses those serializers instead of the default\nModelSerializer that DRF would use.\n\nThis ModelSerializer takes an additional `fields` argument that\ncontrols which fields should be displayed.\nFor more information, refer to the documentation:\nhttps:\/\/www.django-rest-framework.org\/api-guide\/serializers\/#dynamically-modifying-fields\n\n\nExample:\nPortfolioSerializer(required=False, fields=[\"id\", \"name\"])')
export const UsersCarsFormListResponse = zod.array(UsersCarsFormListResponseItem)

/**
 * Adds a GET-only ``aggregate`` action to a viewset.
 *
 * The viewset must declare ``AGGREGATE_CONFIG: AggregateConfig`` and a
 * ``filterset_class``. GET-only because the chat loopback only issues GET.
 */
export const usersCarsKpisByPropertyIdListPathOwnerEmailRegExp = new RegExp('^[^/]+$');


export const UsersCarsKpisByPropertyIdListParams = zod.object({
  "ownerEmail": zod.string().regex(usersCarsKpisByPropertyIdListPathOwnerEmailRegExp),
  "propertyId": zod.string().uuid().describe('UUID of the property.')
})

export const UsersCarsKpisByPropertyIdListQueryParams = zod.object({
  "client_id": zod.array(zod.string()).optional().describe('Multiple values may be separated by commas.'),
  "end_date": zod.string().optional(),
  "ordering": zod.array(zod.enum(['-name', 'name'])).optional().describe('Ordering\n\n\* `name` - Name\n\* `-name` - Name (descending)'),
  "portfolio_id": zod.string().uuid().optional(),
  "property_id": zod.string().uuid().optional(),
  "query": zod.string().optional(),
  "search_cars": zod.string().optional(),
  "start_date": zod.string().optional()
})

export const UsersCarsKpisByPropertyIdListResponseItem = zod.object({
  "id": zod.string().uuid(),
  "ahjId": zod.string(),
  "name": zod.string(),
  "criticalUnit": zod.boolean(),
  "elevatorType": zod.union([zod.enum(['Traction', 'Hydro', 'Other', 'escalator', 'hydraulic-passenger', 'hydraulic-service', 'mrl-traction', 'geared-passenger', 'geared-traction', 'gearless-traction', 'gearless-passenger', 'wheelchair-lift', 'dumbwaiter', 'passenger-service', 'high-rise-passenger', 'low-rise-passenger', 'passenger', 'freight']).describe('\* `Traction` - Traction\n\* `Hydro` - Hydro\n\* `Other` - Other\n\* `escalator` - Escalator\n\* `hydraulic-passenger` - Hydraulic Passenger\n\* `hydraulic-service` - Hydraulic Service\n\* `mrl-traction` - MRL Traction\n\* `geared-passenger` - Geared Passenger\n\* `geared-traction` - Geared Traction\n\* `gearless-traction` - Gearless Traction\n\* `gearless-passenger` - Gearless Passenger\n\* `wheelchair-lift` - Wheelchair Lift\n\* `dumbwaiter` - Dumbwaiter\n\* `passenger-service` - Passenger\/Service\n\* `high-rise-passenger` - High Rise Passenger\n\* `low-rise-passenger` - Low Rise Passenger\n\* `passenger` - Passenger\n\* `freight` - Freight'),zod.literal(null)]).nullable(),
  "installationYear": zod.number().nullable(),
  "modernizationYear": zod.number().nullable(),
  "numLandings": zod.number().nullable(),
  "speedFpm": zod.number().nullable(),
  "capacityLbs": zod.number().nullable(),
  "controllerModel": zod.string(),
  "driveType": zod.string(),
  "lastSspiTest": zod.string().date().nullable(),
  "lastCat1Test": zod.string().date().nullable(),
  "lastCat5Test": zod.string().date().nullable(),
  "numEntrances": zod.number().nullable(),
  "oem": zod.string().nullable(),
  "serviceProviderId": zod.string().uuid().nullable(),
  "callbacks": zod.number().nullable(),
  "callbackRate": zod.number().nullable(),
  "meanTimeBetweenCallbackSecs": zod.number().nullable(),
  "emergencyCallbackRate": zod.number().nullable(),
  "emergencyCalls": zod.number().nullable(),
  "maintenanceCompletion": zod.number().nullable(),
  "maintenanceHours": zod.number().nullable(),
  "maintenanceVisits": zod.number().nullable(),
  "maintenanceFrequency": zod.string(),
  "onTimeResponse": zod.number().nullable(),
  "regularCallbackRateTarget": zod.number(),
  "emergencyCallbackRateTarget": zod.number()
}).strict()
export const UsersCarsKpisByPropertyIdListResponse = zod.array(UsersCarsKpisByPropertyIdListResponseItem)

/**
 * List cars whose maintenance completion fell below the threshold
 * for the given month.
 */
export const usersCarsMissedMaintenanceRetrievePathOwnerEmailRegExp = new RegExp('^[^/]+$');


export const UsersCarsMissedMaintenanceRetrieveParams = zod.object({
  "ownerEmail": zod.string().regex(usersCarsMissedMaintenanceRetrievePathOwnerEmailRegExp)
})

export const usersCarsMissedMaintenanceRetrieveResponseClientIdMax = 255;

export const usersCarsMissedMaintenanceRetrieveResponseNumLandingsMin = 0;
export const usersCarsMissedMaintenanceRetrieveResponseNumLandingsMax = 2147483647;

export const usersCarsMissedMaintenanceRetrieveResponsePropertyOneAddressOneRawMax = 200;

export const usersCarsMissedMaintenanceRetrieveResponsePropertyOneAddressOneFormattedMax = 200;

export const usersCarsMissedMaintenanceRetrieveResponsePropertyOneAddressOneStreetNumberMax = 20;

export const usersCarsMissedMaintenanceRetrieveResponsePropertyOneRegionMax = 255;

export const usersCarsMissedMaintenanceRetrieveResponsePropertyOneClientIdMax = 255;

export const usersCarsMissedMaintenanceRetrieveResponsePropertyOneLatDefault = 0;
export const usersCarsMissedMaintenanceRetrieveResponsePropertyOneLngDefault = 0;
export const usersCarsMissedMaintenanceRetrieveResponsePropertyOnePropertyManagerOneOwnerOneUsernameMax = 150;


export const usersCarsMissedMaintenanceRetrieveResponsePropertyOnePropertyManagerOneOwnerOneUsernameRegExp = new RegExp('^[\\w.@+-]+$');
export const usersCarsMissedMaintenanceRetrieveResponsePropertyOnePropertyManagerOneOwnerOneEmailMax = 254;

export const usersCarsMissedMaintenanceRetrieveResponsePropertyOnePropertyManagerOneOwnerOnePhoneNumberMax = 128;

export const usersCarsMissedMaintenanceRetrieveResponsePropertyOneConsultantGroupOneOwnerOneUsernameMax = 150;


export const usersCarsMissedMaintenanceRetrieveResponsePropertyOneConsultantGroupOneOwnerOneUsernameRegExp = new RegExp('^[\\w.@+-]+$');
export const usersCarsMissedMaintenanceRetrieveResponsePropertyOneConsultantGroupOneOwnerOneEmailMax = 254;

export const usersCarsMissedMaintenanceRetrieveResponsePropertyOneConsultantGroupOneOwnerOnePhoneNumberMax = 128;

export const usersCarsMissedMaintenanceRetrieveResponsePropertyOneConsultantGroupOneConsultantsItemUsernameMax = 150;


export const usersCarsMissedMaintenanceRetrieveResponsePropertyOneConsultantGroupOneConsultantsItemUsernameRegExp = new RegExp('^[\\w.@+-]+$');
export const usersCarsMissedMaintenanceRetrieveResponsePropertyOneConsultantGroupOneConsultantsItemEmailMax = 254;

export const usersCarsMissedMaintenanceRetrieveResponsePropertyOneConsultantGroupOneConsultantsItemPhoneNumberMax = 128;

export const usersCarsMissedMaintenanceRetrieveResponsePropertyOneConsultantGroupOneFileRegExp = new RegExp('(?:jpg|png|jpeg)$');
export const usersCarsMissedMaintenanceRetrieveResponsePropertyOneAssignedConsultantOneUsernameMax = 150;


export const usersCarsMissedMaintenanceRetrieveResponsePropertyOneAssignedConsultantOneUsernameRegExp = new RegExp('^[\\w.@+-]+$');
export const usersCarsMissedMaintenanceRetrieveResponsePropertyOneAssignedConsultantOneEmailMax = 254;

export const usersCarsMissedMaintenanceRetrieveResponsePropertyOneAssignedConsultantOnePhoneNumberMax = 128;

export const usersCarsMissedMaintenanceRetrieveResponsePropertyOneBuildingNumberMax = 255;

export const usersCarsMissedMaintenanceRetrieveResponsePropertyOneContactOneNameMax = 255;

export const usersCarsMissedMaintenanceRetrieveResponseInstallationYearMin = 0;
export const usersCarsMissedMaintenanceRetrieveResponseInstallationYearMax = 2147483647;

export const usersCarsMissedMaintenanceRetrieveResponseModernizationYearMin = 0;
export const usersCarsMissedMaintenanceRetrieveResponseModernizationYearMax = 2147483647;

export const usersCarsMissedMaintenanceRetrieveResponseNumEntrancesMin = 0;
export const usersCarsMissedMaintenanceRetrieveResponseNumEntrancesMax = 2147483647;

export const usersCarsMissedMaintenanceRetrieveResponseSpeedFpmMin = 0;
export const usersCarsMissedMaintenanceRetrieveResponseSpeedFpmMax = 2147483647;

export const usersCarsMissedMaintenanceRetrieveResponseCapacityLbsMin = 0;
export const usersCarsMissedMaintenanceRetrieveResponseCapacityLbsMax = 2147483647;



export const UsersCarsMissedMaintenanceRetrieveResponse = zod.object({
  "id": zod.string().uuid(),
  "clientId": zod.string().max(usersCarsMissedMaintenanceRetrieveResponseClientIdMax).nullish(),
  "customerAccounts": zod.array(zod.object({
  "id": zod.string().uuid(),
  "name": zod.string()
}).strict().describe('A subclass of DRF\'s ModelSerializer which realizes when fields it is\nserializing are to related objects which also have NestableModelSerializers\ndefined for them and uses those serializers instead of the default\nModelSerializer that DRF would use.\n\nThis ModelSerializer takes an additional `fields` argument that\ncontrols which fields should be displayed.\nFor more information, refer to the documentation:\nhttps:\/\/www.django-rest-framework.org\/api-guide\/serializers\/#dynamically-modifying-fields\n\n\nExample:\nPortfolioSerializer(required=False, fields=[\"id\", \"name\"])')),
  "name": zod.string(),
  "status": zod.string(),
  "numLandings": zod.number().min(usersCarsMissedMaintenanceRetrieveResponseNumLandingsMin).max(usersCarsMissedMaintenanceRetrieveResponseNumLandingsMax).nullish(),
  "elevatorType": zod.union([zod.enum(['Traction', 'Hydro', 'Other', 'escalator', 'hydraulic-passenger', 'hydraulic-service', 'mrl-traction', 'geared-passenger', 'geared-traction', 'gearless-traction', 'gearless-passenger', 'wheelchair-lift', 'dumbwaiter', 'passenger-service', 'high-rise-passenger', 'low-rise-passenger', 'passenger', 'freight']).describe('\* `Traction` - Traction\n\* `Hydro` - Hydro\n\* `Other` - Other\n\* `escalator` - Escalator\n\* `hydraulic-passenger` - Hydraulic Passenger\n\* `hydraulic-service` - Hydraulic Service\n\* `mrl-traction` - MRL Traction\n\* `geared-passenger` - Geared Passenger\n\* `geared-traction` - Geared Traction\n\* `gearless-traction` - Gearless Traction\n\* `gearless-passenger` - Gearless Passenger\n\* `wheelchair-lift` - Wheelchair Lift\n\* `dumbwaiter` - Dumbwaiter\n\* `passenger-service` - Passenger\/Service\n\* `high-rise-passenger` - High Rise Passenger\n\* `low-rise-passenger` - Low Rise Passenger\n\* `passenger` - Passenger\n\* `freight` - Freight'),zod.enum(['']),zod.literal(null)]).nullish(),
  "property": zod.object({
  "id": zod.string().uuid(),
  "createdAt": zod.string().datetime({"offset":true}),
  "updatedAt": zod.string().datetime({"offset":true}).nullable(),
  "name": zod.string(),
  "address": zod.object({
  "id": zod.number(),
  "raw": zod.string().max(usersCarsMissedMaintenanceRetrieveResponsePropertyOneAddressOneRawMax),
  "formatted": zod.string().max(usersCarsMissedMaintenanceRetrieveResponsePropertyOneAddressOneFormattedMax).optional(),
  "streetNumber": zod.string().max(usersCarsMissedMaintenanceRetrieveResponsePropertyOneAddressOneStreetNumberMax).optional(),
  "street": zod.string(),
  "city": zod.string().nullable(),
  "postalCode": zod.string().nullable(),
  "state": zod.string().nullable(),
  "country": zod.string().nullable()
}).strict().nullable(),
  "region": zod.string().max(usersCarsMissedMaintenanceRetrieveResponsePropertyOneRegionMax).nullish(),
  "clientId": zod.string().max(usersCarsMissedMaintenanceRetrieveResponsePropertyOneClientIdMax).nullish(),
  "timeZone": zod.string().optional(),
  "lat": zod.number().nullable().default(usersCarsMissedMaintenanceRetrieveResponsePropertyOneLatDefault),
  "lng": zod.number().nullable().default(usersCarsMissedMaintenanceRetrieveResponsePropertyOneLngDefault),
  "propertyManager": zod.object({
  "id": zod.string().uuid(),
  "name": zod.string(),
  "owner": zod.object({
  "id": zod.string().uuid(),
  "username": zod.string().max(usersCarsMissedMaintenanceRetrieveResponsePropertyOnePropertyManagerOneOwnerOneUsernameMax).regex(usersCarsMissedMaintenanceRetrieveResponsePropertyOnePropertyManagerOneOwnerOneUsernameRegExp).describe('Required. 150 characters or fewer. Letters, digits and @\/.\/+\/-\/_ only.'),
  "email": zod.string().email().max(usersCarsMissedMaintenanceRetrieveResponsePropertyOnePropertyManagerOneOwnerOneEmailMax).optional(),
  "phoneNumber": zod.string().max(usersCarsMissedMaintenanceRetrieveResponsePropertyOnePropertyManagerOneOwnerOnePhoneNumberMax).optional(),
  "fullName": zod.string(),
  "consultantGroup": zod.string().nullable(),
  "clientGroup": zod.string().nullable(),
  "role": zod.union([zod.enum(['consultant', 'client', 'service_provider']).describe('\* `consultant` - consultant\n\* `client` - client\n\* `service_provider` - service_provider'),zod.literal(null)]).nullable(),
  "isLiftaiAdmin": zod.boolean(),
  "isGroupAdmin": zod.boolean()
}).strict().nullable()
}).strict().nullable(),
  "consultantGroup": zod.object({
  "name": zod.string(),
  "id": zod.string().uuid(),
  "owner": zod.object({
  "id": zod.string().uuid(),
  "username": zod.string().max(usersCarsMissedMaintenanceRetrieveResponsePropertyOneConsultantGroupOneOwnerOneUsernameMax).regex(usersCarsMissedMaintenanceRetrieveResponsePropertyOneConsultantGroupOneOwnerOneUsernameRegExp).describe('Required. 150 characters or fewer. Letters, digits and @\/.\/+\/-\/_ only.'),
  "fullName": zod.string(),
  "email": zod.string().email().max(usersCarsMissedMaintenanceRetrieveResponsePropertyOneConsultantGroupOneOwnerOneEmailMax).optional(),
  "phoneNumber": zod.string().max(usersCarsMissedMaintenanceRetrieveResponsePropertyOneConsultantGroupOneOwnerOnePhoneNumberMax).optional()
}).strict().nullable(),
  "consultants": zod.array(zod.object({
  "id": zod.string().uuid(),
  "username": zod.string().max(usersCarsMissedMaintenanceRetrieveResponsePropertyOneConsultantGroupOneConsultantsItemUsernameMax).regex(usersCarsMissedMaintenanceRetrieveResponsePropertyOneConsultantGroupOneConsultantsItemUsernameRegExp).describe('Required. 150 characters or fewer. Letters, digits and @\/.\/+\/-\/_ only.'),
  "fullName": zod.string(),
  "email": zod.string().email().max(usersCarsMissedMaintenanceRetrieveResponsePropertyOneConsultantGroupOneConsultantsItemEmailMax).optional(),
  "phoneNumber": zod.string().max(usersCarsMissedMaintenanceRetrieveResponsePropertyOneConsultantGroupOneConsultantsItemPhoneNumberMax).optional()
}).strict()),
  "file": zod.string().url().regex(usersCarsMissedMaintenanceRetrieveResponsePropertyOneConsultantGroupOneFileRegExp).nullish()
}).strict().nullable(),
  "assignedConsultant": zod.object({
  "id": zod.string().uuid(),
  "username": zod.string().max(usersCarsMissedMaintenanceRetrieveResponsePropertyOneAssignedConsultantOneUsernameMax).regex(usersCarsMissedMaintenanceRetrieveResponsePropertyOneAssignedConsultantOneUsernameRegExp).describe('Required. 150 characters or fewer. Letters, digits and @\/.\/+\/-\/_ only.'),
  "email": zod.string().email().max(usersCarsMissedMaintenanceRetrieveResponsePropertyOneAssignedConsultantOneEmailMax).optional(),
  "phoneNumber": zod.string().max(usersCarsMissedMaintenanceRetrieveResponsePropertyOneAssignedConsultantOnePhoneNumberMax).optional(),
  "fullName": zod.string(),
  "consultantGroup": zod.string().nullable(),
  "clientGroup": zod.string().nullable(),
  "role": zod.union([zod.enum(['consultant', 'client', 'service_provider']).describe('\* `consultant` - consultant\n\* `client` - client\n\* `service_provider` - service_provider'),zod.literal(null)]).nullable(),
  "isLiftaiAdmin": zod.boolean(),
  "isGroupAdmin": zod.boolean()
}).strict().nullable(),
  "portfolio": zod.object({
  "id": zod.string().uuid(),
  "name": zod.string()
}).strict().nullable(),
  "unitCount": zod.number(),
  "buildingNumber": zod.string().max(usersCarsMissedMaintenanceRetrieveResponsePropertyOneBuildingNumberMax).optional(),
  "contact": zod.object({
  "id": zod.string().uuid(),
  "name": zod.string().max(usersCarsMissedMaintenanceRetrieveResponsePropertyOneContactOneNameMax),
  "email": zod.string().email().nullish(),
  "phone": zod.string().nullish(),
  "createdAt": zod.string().datetime({"offset":true}),
  "updatedAt": zod.string().datetime({"offset":true})
}).strict().nullish()
}).strict(),
  "serviceProviderId": zod.string().uuid().nullable(),
  "ahjId": zod.string().optional(),
  "criticalUnit": zod.boolean().optional(),
  "installationYear": zod.number().min(usersCarsMissedMaintenanceRetrieveResponseInstallationYearMin).max(usersCarsMissedMaintenanceRetrieveResponseInstallationYearMax).nullish(),
  "modernizationYear": zod.number().min(usersCarsMissedMaintenanceRetrieveResponseModernizationYearMin).max(usersCarsMissedMaintenanceRetrieveResponseModernizationYearMax).nullish(),
  "numEntrances": zod.number().min(usersCarsMissedMaintenanceRetrieveResponseNumEntrancesMin).max(usersCarsMissedMaintenanceRetrieveResponseNumEntrancesMax).nullish(),
  "speedFpm": zod.number().min(usersCarsMissedMaintenanceRetrieveResponseSpeedFpmMin).max(usersCarsMissedMaintenanceRetrieveResponseSpeedFpmMax).nullish(),
  "capacityLbs": zod.number().min(usersCarsMissedMaintenanceRetrieveResponseCapacityLbsMin).max(usersCarsMissedMaintenanceRetrieveResponseCapacityLbsMax).nullish(),
  "lastSspiTest": zod.string().date().nullish(),
  "lastCat1Test": zod.string().date().nullish(),
  "lastCat5Test": zod.string().date().nullish(),
  "driveType": zod.string().optional(),
  "controllerModel": zod.string().optional(),
  "oem": zod.string().uuid().nullable(),
  "manufacturer": zod.string().nullable(),
  "serviceProviderInternalId": zod.string().nullable()
}).strict().describe('A subclass of DRF\'s ModelSerializer which realizes when fields it is\nserializing are to related objects which also have NestableModelSerializers\ndefined for them and uses those serializers instead of the default\nModelSerializer that DRF would use.\n\nThis ModelSerializer takes an additional `fields` argument that\ncontrols which fields should be displayed.\nFor more information, refer to the documentation:\nhttps:\/\/www.django-rest-framework.org\/api-guide\/serializers\/#dynamically-modifying-fields\n\n\nExample:\nPortfolioSerializer(required=False, fields=[\"id\", \"name\"])')

/**
 * Check if a user has permission to access a specific resource. Without this annotation drf-spectacular guesses the viewset's UserDetail serializer for the request/response, which is wrong.
 */



export const UsersCheckPermissionCreateBody = zod.object({
  "email": zod.string().email().min(1),
  "kind": zod.enum(['invoice', 'proposal']).describe('\* `invoice` - invoice\n\* `proposal` - proposal'),
  "id": zod.string().uuid()
}).describe('Serializer for check-permission request payload')

export const UsersCheckPermissionCreateResponse = zod.object({
  "hasPermission": zod.boolean(),
  "userEmail": zod.string().email(),
  "kind": zod.string(),
  "resourceId": zod.string()
}).strict().describe('Serializer for the check-permission success response payload')

/**
 * Email a client a spending notification for an invoice/proposal. Without this annotation drf-spectacular guesses the viewset's UserDetail serializer for the request body, which is wrong.
 */








export const UsersSendSpendingNotificationCreateBody = zod.object({
  "spendingClass": zod.enum(['Invoice', 'Proposal']).describe('\* `Invoice` - Invoice\n\* `Proposal` - Proposal'),
  "spendingNumber": zod.string().min(1),
  "spendingProvider": zod.string().min(1),
  "spendingProperty": zod.string().min(1),
  "spendingId": zod.string().min(1),
  "clientEmail": zod.string().email().min(1),
  "targetUrl": zod.string().url().min(1)
}).describe('Serializer for spending notification request payload')

export const UsersSendSpendingNotificationCreateResponse = zod.record(zod.string(), zod.unknown())

